<template>
  <div class="order-wrapper payment-wrapper" :class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <PrimaryFilter v-if="!isInitLoading" :menuOptions="menuOptions" :selectedCategory="selectedCategory"
        :buttonsList="getIndentButtons" :isUploading="isUploading" :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParametersWithConfig" :searchText="searchText" :preSearchedParams="searchedParams"
        @changeCategory="changeCategory" @indentMaterialSampleDownload="indentMaterialSampleDownload"
        @indentMaterialDeleteSampleDownload="indentMaterialDeleteSampleDownload"
        @indentMaterialInvoiceGrnSampleDownload="indentMaterialInvoiceGrnSampleDownload"
        @indentBulkSampleDownload="indentBulkSampleDownload"
        @directDeliveryIndentBulkSampleDownload="directDeliveryIndentBulkSampleDownload" @bulkUpload="bulkUpload"
        @directDeliveryBulkUpload="directDeliveryBulkUpload"
        @indentDirectDispatchSampleDownload="indentDirectDispatchSampleDownload"
        @indentDirectDispatchBulkUpload="directDispatchBulkUpload"
        @chargeableWeightBulkUpload="chargeableWeightBulkUpload" @podBulkUpload="podBulkUpload"
        @consigneePodFileUpload="consigneePodFileUpload" :isInbound="isInbound" @materialBulkUpload="materialBulkUpload"
        @indentMaterialDeleteUpload="indentMaterialDeleteUpload"
        @indentMaterialInvoiceGrnBulkUpload="indentMaterialInvoiceGrnBulkUpload" @rejectDownload="rejectDownload"
        @grnRejectDownload="grnRejectDownload" @materialRejectDownload="materialRejectDownload"
        @directDeliveryRejectDownload="directDeliveryRejectDownload"
        @materialInvoiceGrnRejectDownload="materialInvoiceGrnRejectDownload"
        @materialDeleteRejectDownload="materialDeleteRejectDownload"
        @chargeableWeightRejectDownload="chargeableWeightRejectDownload" @openManifest="openManifest"
        @searchByParameter="searchByParameter" @setGA="setGA" @lrBulkUpload="lrBulkUpload"
        @lrSampleDownload="lrSampleDownload" @lrRejectedDownload="lrRejectedDownload"
        @handleClose = "handleClose" />
    </portal>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loadCheck" infinite-scroll-throttle-delay="400"
      infinite-scroll-distance="10">
      <div class="flex-container page-filter">
        <div class="flex-item">
          <div class="filter-action pr-0" v-if="controlTowerListing">
            <span class="icon-circle">
              <svgicon name="dashboard-applied" width="10" height="10" :original="true" />
            </span>
            {{controlTowerParameters[$route.query.metricType]}} {{$t('INDENT_FILTER_FROM_OPS_CONTROL_TOWER')}}
            <Button type="text" size="mini" class="button-text-blue ml-10"
              @click="routeToIndents">{{$t('INDENT_RESET_ALL')}}</Button>
          </div>
          <div v-else>
            <FilterWrapper :values="filterTags" @openSliderLeft="openSlideleft = !openSlideleft">
            </FilterWrapper>
          </div>
        </div>

      </div>
      <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
        <div class="slideleft_content">
          <div class="content">
            <div class="flex-container w-400 justify-content-md-start"
              v-if="openSearchGlobal && isPackingIndentEnabled">
              <div class="icon-rounded">
                <span class="remove-icon">
                  <svgicon name="search" width="12" height="12" :original="true" />
                </span>
              </div>
              <div>
                {{$t('INDENT_GLOBAL_SEARCH')}}
              </div>
              <div>
                <Button type="text" @click="resetGlobalSearch">{{$t('INDENT_RESET_ALL')}}</Button>
              </div>

            </div>
            <div class="order-list-wrapper" sticky-container>
              <Header :headers="getListHeaders()" :sortOptions="sortOptions" :filterOptions="listFilterOptions"
                :selectedFilterOption="selectedFilterOption" :setSortOptionConfig="setSortOptionConfig"
                @updateFilterOption="updateFilterOption" @clearFilterOption="clearFilterOption"
                @setSortOption="sortBy" />
              <div v-if="isOrdersLoading">Loading...</div>
              <Rows v-else v-for="order in orders" :headers="getListHeaders()" :order="order"
                :isVendorDepotUser="isVendorDepotUser" :vendorDepots="vendorDepots" :selectedOrder="selectedOrder"
                :configurations="configurations" :utilizationStatus="utilizationStatus" :movement="movement"
                :deliveryTypes="deliveryTypes" :movementTypes="movementListType" :orderType="orderType"
                :userEditPermission="userEditPermission" :isFilterClosed="!openSlideleft"
                :truckDetainedConfig="truckDetainedConfig" :depotConfigDetails="depotConfigDetails" :key="order.id"
                @showOrder="showOrder" @showWeights="handleWeights" @setGA="setGA"
                @setSelectedAction="setSelectedAction($event, order.id)" @getPtl="getPtlGrouping"
                @set-reindent-info="setReindentInfo" @getBaseFreight="getBaseFreightCharges" />
              <div v-if="!isOrdersLoading && orders.length === 0" class="no-order-data">
                {{ $t('INDENT_NO_RECORDS') }}
              </div>
              <div v-if="isPaginating">
                <Spinner />
              </div>
            </div>
          </div>
        </div>
        <div class="slideleft_menu">
          <SecFilter v-if="!controlTowerListing" :selectedFilters="filterConstant"
            :selectedDateFilter="selectedDateFilter" :filters="filters" @search="search" @updateOption="updateOption"
            @updateRadio="updateRadio" @disableDeliver="disableDeliver" @reset="resetApply" @clearDate="clearDate" />
        </div>
      </div>
    </div>

    <Drawer
    direction="rtl" size="400px" :modal="true" :withHeader="false"
    class="default-drawer"
    :visible.sync="drawer"
    :before-close="handleBeforeClose">
      <div class="drawer-header px-15 bg-grey-dark align-item-center">
        <div class="text-white text-md">LR Bulk Download
          <span class="text-grey-dark ml-5 bg-beta-tag">Beta</span>
        </div>
        <div class="f-right">
          <Button size="small" type="dark" @click="handleClose">Close</Button>
        </div>
      </div>
      <div class="drawer-body bg-gradient-ai">
        <div style="height: calc(100% - 100px) !important; overflow: scroll;" :class="{ 'empty-lr-details': enteredLRdetails.length === 0 }" >
            <div v-if="enteredLRdetails.length === 0" style="display: flex;align-items: center; height: 50%; flex-direction: column; gap: 35px;padding: 0 25px;">
              <div class="icon-container">
                <div class="background-blur"></div>
                <svgicon name="no-file-uploaded" width="40" height="40" :original="true" style="z-index: 2;"/>
              </div>
              <h2 class="text-sm text-grey_lighter10" style="text-align: center;">
                Enter your LR or consignment numbers, separated by commas, to download them all at once.
              </h2>
            </div>
          
          <div v-for="(lrDetail, index) in enteredLRdetails" class="lr-details-wrapper">
            <div v-if="lrDetail.lrNumbers.length > 0 && lrDetail.isLoading" class="bg-wrapper-items mb-15">
              <h2 class="text-grey_lighter10 text-sm m-0 pb-10">Entered LR Number(s) :</h2>
              <div class="text-grey_lighter10 text-sm">
                {{ lrDetail.lrNumbers.join(', ') }}
              </div>
            </div>
            <div v-if="lrDetail.isLoading" class="typing-loader">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div v-show="!lrDetail.isLoading && lrDetail.lrNumbers.length > 0">
              <div class="flex-center mb-5 align-item-center">
                <div><h2 class="text-grey_lighter10 text-sm">Documents :</h2></div>
                <div>
                  <span class="text-white text-xs text-capitalize text-bold pointer" style="letter-spacing: 0.3px;" @click="downloadLRDetails(lrDetail.lrTableData)">
                    <svgicon name="icon-download" width="12" height="12" :original="true" class="mr-5" />
                    Download All
                  </span>
                </div>
              </div>
              <Table
                class="table-dark"
                :data="lrDetail.lrTableData"
                :stripe="true"
                style="width: 100%">
                <TableColumn
                  prop="sno"
                  label="S.No"
                  width="50">
                </TableColumn>
                <TableColumn
                  prop="lrnumber"
                  label="Lr Number"
                  width="150">
                  <template slot-scope="scope">
                    <div class="skeleton-container" v-if="lrDetail.lrnumber">
                      <div class="skeleton skeleton-row"></div>
                    </div>
                    <div v-else>
                      <span>{{ scope.row.lrnumber }}</span>
                    </div>
                  </template>
                </TableColumn>
                <TableColumn
                  prop="available"
                  label="Available">
                  <template slot-scope="scope">
                    <span v-if="lrDetail.isLoading && !lrDetail.showSuccessMessage" class="spinner"></span>
                    <span v-else-if="scope.row.available" class="pointer" @click="downloadLRDetails(scope.row)"> <svgicon name="icon-download" width="12" height="12" :original="true" class="mr-5" />   </span>
                    <span v-else class="text-md text-red"> NA </span>
                  </template>
                </TableColumn>
              </Table>
            </div>
            <div v-if="lrDetail.showSuccessMessage">
              <h2 class="text-sm text-grey_lighter10 d-flex align-item-center">
                LR Documents Found
                <svgicon name="green-circle-tick" width="12" height="12" :original="true" class="mr-5 ml-10" />
              </h2>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mb-15 input-wrapper input-wrapper-ai align-item-center" style="margin-top: auto;">
          <Input
            v-model="inputValue"
            class="input-blank chatbot-pi-input-field text-sm italic-font"
            :disabled="showTyping"
            placeholder="Enter the LR Number(s) (max 25)"
            @input="handleInput"
            @keyup.enter.native="searchLRNumbers"
            style="text-transform: capitalize;" />
          <Button
            :disabled="showTyping"
            class="ask-pi-button mr-10"
            circle
            @click="searchLRNumbers">
            <svgicon name="icon-arrow-up" width="16" height="18" :original="true" />
          </Button>
        </div>
      </div>
    </Drawer>
    <Drawer :visible.sync="isDetailsEnabled" direction="rtl" size="800px" :modal="true" :withHeader="false"
      :append-to-body="true" :before-close="closeDrawer" class="default-drawer">
      <Link :underline="false" class="nav-close" @click="closeDrawer">
      <svgicon name="cancelwhite" width="12" height="12" :original="true" />
      </Link>
      <div v-if="hasDataLoaded">
        <div class="drawer-header px-15">
          {{ order.order_number }}
          <div class="header-action">
            <span v-if="enableAddReturn">
              <!-- <router-link
                class="link-text"
                :to="{ name: 'CreateReturn', params: { orderId: order.order_number }}"
              > -->
              <Button type="text" class="button-link" @click="showReturnDialog = true">
                <svgicon name="icon-return" width="10" height="10" />
                {{ $t('INDENT_ADD_RETURN') }}
              </Button>
              <Dialog width="400px" middle="true" :center="false" title="Create Return Indent?" :append-to-body="true"
                :visible.sync="showReturnDialog" class="default-dialog">
                <return-dialog :order="order" @closeDialog="closeReturnDialog">
                </return-dialog>
              </Dialog>
            </span>
            <span v-permission="['change_truck_type']">
              <router-link class="link-text" v-if="
                  !isDispatched &&
                  [4, 16, 22, 24, 5, 17, 18, 26].includes(order.status) &&
                  !hideEditIndentOption
                " :to="{
                  name: 'changeTruckType',
                  params: {
                    orderId: order.order_number,
                    type: filterParams.category,
                  },
                }">
                <svgicon name="icon_vehicle" width="10" height="10" />
                {{ $t('INDENT_UPDATE_TRUCK_TYPE') }}
              </router-link>
            </span>
            <span v-if="enableRetryModifiedPicklist">
              <Button type="text" size="small" class="button-link" @click="retryModifiedPicklist">
                <svgicon name="re-indent" width="8" height="8" />
                {{ $t('INDENT_RETRY_MODIFIED_PICKLIST') }}
              </Button>
            </span>
            <span v-if="
                userEditPermission[`${order.order_type}`] &&
                order.order_type != orderType.MARKET &&
                !isDispatched &&
                !hideEditIndentOption
              ">
              <router-link class="link-text" :to="editIndentRoute">
                <svgicon name="icon-edit" width="10" height="10" />
                {{ $t('INDENT_EDIT') }}
              </router-link>
            </span>
            <span v-if="enableCancel && !$statusUtil.isDrafted(order.status)">
              <Button type="text" size="small" class="button-link" @click="cancelindent = true">
                <svgicon name="icon-close" width="8" height="8" />
                <span v-if="!openSlideleft">{{ $t('INDENT_CANCEL') }}</span>
              </Button>
            </span>
            <span v-if="$statusUtil.isDrafted(order.status)">
              <Button type="text" size="small" class="button-link" @click="canceldraft = true">
                <svgicon name="icon-close" width="8" height="8" />
                <span v-if="!openSlideleft">{{
                  $t('INDENT_CANCEL_DRAFT')
                  }}</span>
              </Button>
            </span>
            <span v-if="canReship && !$statusUtil.isDrafted(order.status)">
              <Button type="text" size="small" class="button-link" @click="reshipindent = true">
                <i class="el-icon-refresh" />
                <span v-if="!openSlideleft">{{ $t('INDENT_RESHIP') }}</span>
              </Button>
            </span>
            <span v-if="canChangeShipMethod && !$statusUtil.isDrafted(order.status)">
              <Button type="text" size="small" class="button-link" @click="changeShipMethod = true">
                <i class="el-icon-refresh" />
                <span v-if="!openSlideleft">{{$t('INDENT_CHANGE_SHIP_METHOD')}}</span>
              </Button>
            </span>
            <span v-if="cloneShowStatus">
              <router-link class="link-text" :to="{
                  name: 'indentClone',
                  params: {
                    orderId: order.order_number,
                    type: filterParams.category,
                  },
                  query: { type: order.order_sub_type },
                }">
                <svgicon name="icon-clone" width="10" height="10" />
                {{ $t('INDENT_CLONE') }}
              </router-link>
            </span>
          </div>
        </div>
        <div class="drawer-body drawer-scroll p-0" v-if="order.order_number">
          <ElTabs class="tab-default tab-sm tab-bg" v-model="currentSelectedTab">
            <Tab-pane label="Actions" name="actions" v-if="selectedAction">
              <div class="tab-content">
                <MarkAsDeliveredActions v-if="selectedAction === indentActions.MARK_AS_DELIVERED" :inbound="isInbound"
                  :order="order" :selectedAction="selectedAction" :datePickerFormat="datePickerFormat"
                  :getBackDateConfig="getBackDateConfig" :isPrimary="movementTypes.PRIMARY === order.movement"
                  :truckDetainedConfig="truckDetainedConfig" @done="closeDrawer" @closeDrawer="closeDrawer" />
                <Actions v-else :isInbound="isInbound" :indent="order" :selectedAction="selectedAction"
                  :ceilingPrice="ceilingPrice" :freightUnit="freightUnit" :deliveryType="deliveryTypes"
                  :isEligibleForPtlGrouping="isEligibleForPtlGrouping" :ptlGroups="ptlGroups"
                  @changeCeilingPrice="changeCeilingPrice" @closeDrawer="closeDrawer" />
              </div>
            </Tab-pane>
            <Tab-pane :label="trackTabTitle" name="track" v-if="selectedAction && trackTabTitle">
              <div class="tab-content">
                <div class="content-scroll-inner mx-pd-15" style="width:800px">
                  <Track :indent="order" :simTrackingEnabled="simTrackingEnabled"
                    :isSimTrackingAllowed="isSimTrackingAllowed" :gpsTrackingEnabled="gpsTrackingEnabled"
                    :yetToTruckIn="yetToTruckIn" :hasDriverAccepted="hasDriverAccepted"
                    :appTrackingEnabled="appTrackingEnabled" :hyperTrackingEnabled="hyperTrackingEnabled"
                    :trackingAfterTruckOut="trackingAfterTruckOut" :mapConfig="mapConfig" @closeDrawer="closeDrawer" />
                </div>
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('INDENT_DETAILS')" name="details">
              <div class="tab-content">
                <div class="content-scroll-inner mx-pd-15" style="width: 800px">
                  <Depot :order="order" :configurations="configurations" :baseFreightCharge="baseFreightCharge" />
                  <div v-if="canReship">
                    <Checkbox v-model="reShipProxyAllDeliveries" @change="toggleReShip">
                      Select all cartons for Re-ship
                    </Checkbox>
                  </div>
                  <Collapse v-model="activeName" accordion class="collapse-slider mx-15">
                    <CollapseItem v-for="(source, index) in getMaterials(order.material_map)" :key="index" :title="(Object.keys(order.material_map).length > 1  &&
                    source.is_parent_indent) ? source.deliveryId+'*' : source.deliveryId" :name="index">
                      <DeliveryDetails v-if="activeName === index && currentSelectedTab === 'details'"
                        :deliveryId="source.deliveryId" @changeCarton="cartonChange" @allCartons="selectAllCartonChange"
                        :reShipAllDeliveries="reShipAllDeliveries" :canReship="canReship"
                        :selectedCartons="selectedCartons.get(source.deliveryId)" :orderDetails="order">
                      </DeliveryDetails>
                    </CollapseItem>
                    <CollapseItem :title="$t('INDENT_OTHER_INFORMATION')" name="1" v-if="showPurchaseOrderDetails ||
                    $hasFeature('weigh_bridge') || hasCustomFields">
                      <div class="flex-container panel-head align-top mb-15" v-if="showPurchaseOrderDetails">
                        <div class="flex-item floating">
                          <p v-bind:class="{ 'f-right text-right': ind % 2 }" v-for="(item, ind) in purchaseOrderFields"
                            v-bind:key="ind">
                            {{ item.label }} :
                            <strong>{{
                              order.purchase_order_details[item.name]
                              }}</strong>
                          </p>
                        </div>
                      </div>
                      <WeighInWeightOut v-if="$hasFeature('weigh_bridge') && order" :showActions="true"
                        :orderDetails="order" :hideEdit="!showEditWeighBridge">
                      </WeighInWeightOut>
                      <CustomField v-if="hasCustomFields" :currentIndent="order"
                        :indentCustomFields="indentCustomFields" :indentSourceCustomFields="indentSourceCustomFields"
                        :indentDestinationCustomFields="indentDestinationCustomFields"
                        :customFields="order.custom_fields" />
                    </CollapseItem>
                    <CollapseItem :title="$t('INDENT_WEIGHTS')" name="2" v-if="$hasFeature('truck_weights')">
                      <Form :inline="true" class="form-default form-triple" :disabled="isDisabledInput">
                        <div class="save-button-container">
                          <Button type="primary" @click="saveWeight"
                            :disabled="FreezeSaveButton || !$hasPermission('set_truck_weights')"
                            @closeDrawer="closeDrawer">
                            {{ $t('SAVE') }}
                          </Button>
                        </div>
                        <div class="item-group">
                          <FormItem :label="$t('INDENT_TARE_WEIGHT')" required>
                            <Input type="number" step="any" :placeholder="$t('INDENT_ENTER_TARE_WEIGHT')"
                              v-model="localTareWeight" size="small" required
                              :disabled="isTareWeightDisabled || !$hasPermission('set_truck_weights')"
                              @input="checkFreezeButton" />
                          </FormItem>

                          <FormItem :label="$t('INDENT_GROSS_WEIGHT')" required>
                              <Input type="number" step="any" :placeholder="$t('INDENT_ENTER_GROSS_WEIGHT')"
                              v-model="localGrossWeight" size="small" required
                              :disabled="isGrossWeightFrozen || !$hasPermission('set_truck_weights')"
                              @input="checkFreezeButton" />
                          </FormItem>
                        </div>
                      </Form>

                      <div class="reason_dropdown custom-dropdown-width">
                        <div>
                          <h3>{{ $t('INDENT_COMMENTS') }}</h3>
                        </div>
                        <div class="dialog-content dialog-scroll">
                          <Form class="form-default">
                            <FormItem :label="$t('INDENT_REASON_UPDATE')">
                              <Select v-model="selectedReason" :placeholder="$t('INDENT_REASON_UPDATE')" size="mini"
                                class="select-default content_text reason-select" @input="checkFreezeButton"
                                :disabled="false">
                                <Option v-for="item in nullUpdateOptions" :key="item.type" :value="item.label">
                                  {{ item.label }}
                                </Option>
                              </Select>
                            </FormItem>

                            <div v-if="selectedReason && selectedReason === $t('OTHERS')">
                              <FormItem :label="$t('OTHERS')">
                                <Input :placeholder="$t('INDENT_ENTER_REASON') + $t('INDENT_REASON_VALIDATION')"
                                  :maxlength="150" :minlength="15" :rows="2" type="textarea" class="form-control"
                                  v-model="customComment" @input="checkFreezeButton">
                                </Input>
                              </FormItem>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </CollapseItem>
                    <CollapseItem v-for="(source, index) in getOrderData" :key="`${isInbound ? 'inbound' : 'outbound'}-${
                        source.unique_id
                      }`" :title="
                        sourceHasGate(
                          source.gate_id,
                          source.location_id,
                          source
                        )
                      " :name="index">
                      <div class="flex-container panel-head align-top">
                        <div class="flex-item">
                          <p>
                            {{ $t('INDENT_REFERENCE_ID') }} :
                            <strong>{{
                              sourceHasGateRefrenceId(
                              source.gate_id,
                              source.location_id,
                              source
                              )
                              }}</strong>
                          </p>
                          <p v-if="!hasDocks">
                            {{ $t('INDENT_LOADERS') }} :
                            <strong>{{
                              source.loader_available
                              ? $t('INDENT_YES')
                              : $t('INDENT_NO')
                              }}</strong>
                          </p>
                        </div>
                        <div class="flex-item text-right">
                          <p>
                            {{ $t('INDENT_VEHICLE_REQUIREMENT_DATE') }} :
                            <strong>{{
                              source.loading_date | moment('DD MMM YYYY')
                              }}</strong>
                          </p>
                          <p v-if="!hasDocks">
                            {{ $t('INDENT_PAID_BY') }} :
                            <strong>{{
                              source.add_to_invoice
                              ? $t('INDENT_YES')
                              : $t('INDENT_NO')
                              }}</strong>
                          </p>
                        </div>
                      </div>
                      <Table :data="
                          source.gate_id
                            ? getGateDestinations(source)
                            : getSourceDestinations(source)
                        " :stripe="true" align="top" class="table-striped bordered my-15" max-height="250px"
                        aria-describedby="orderListDestiantionData">
                        <TableColumn :label="$t('INDENT_SHIPPED_TO')" width="210">
                          <template slot-scope="scope">
                            <span v-if="!scope.row.consignmentNumber">
                              <span class="d-block">{{
                                scope.row.shipped_to
                                }}</span>
                              <Ellipsis class="text-xs" :text="getShippedToRefIdWithCity(scope.row)" :length="25" />
                            </span>

                            <span v-if="scope.row.consignmentNumber">
                              <span class="d-block">{{
                                scope.row.shipped_to
                                }}</span>
                              <Tooltip :open-delay="200" effect="dark" placement="bottom">
                                <span class="pointer">
                                  <Ellipsis class="text-xs" :text="getShippedToRefIdWithCity(scope.row)" :length="25" />
                                </span>
                                <div slot="content">
                                  {{ $t('INDENT_CONSIGNMENT_NUMBER') }} :{{
                                  scope.row.consignmentNumber
                                  }}
                                </div>
                              </Tooltip>
                            </span>
                          </template>
                        </TableColumn>
                        <TableColumn :label="$t('INDENT_SOLD_TO')" width="210">
                          <template slot-scope="scope">
                            <span class="d-block">{{ scope.row.sold_to }}</span>
                            <Ellipsis class="text-xs" :text="getSoldToRefIdWithCity(scope.row)" :length="25" />
                          </template>
                        </TableColumn>
                        <TableColumn prop="expected_date" v-if="!deliveryWindow"
                          :label="$t('INDENT_EXPECTED_DATE_TIME')" width="155"></TableColumn>
                        <TableColumn v-else :label="$t('INDENT_DELIVERY_WINDOW')" width="140">
                          <template slot-scope="scope">
                            <div>
                              <div>{{scope.row.expected_date}}</div>
                              <div class="text-xs">
                                <span>{{getFirstWindow(scope.row.delivery_window)}}</span>
                                <Tooltip v-if="getDeliveryWindow(scope.row.delivery_window)" class="item " effect="dark"
                                  placement="bottom" :open-delay="300">
                                  <div slot="content" class="jumbotron tooltipcontent">
                                    {{getExceptFirstWindow(scope.row.delivery_window)}}
                                  </div>
                                  <span class="text-tag">{{getDeliveryWindow(scope.row.delivery_window)}}</span>
                                </Tooltip>
                              </div>

                            </div>
                          </template>

                        </TableColumn>
                        </TableColumn>
                        <TableColumn prop="unloaders" :label="$t('INDENT_UNLOADERS')" width="100">
                        </TableColumn>
                        <TableColumn prop="paid_by" :label="$t('INDENT_PAID_BY')">
                        </TableColumn>
                      </Table>
                    </CollapseItem>
                  </Collapse>

                </div>
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('INDENT_DOCUMENTS')" name="documents"
              v-if="isPackingIndentEnabled && order.status !== 8">
              <div class="tab-content" v-if="order">
                <DocumentView v-if="currentSelectedTab === 'documents'" :order="order">
                </DocumentView>
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('INDENT_TIMELINE')"
              v-if="checkOrderStatus(order.status) && !$statusUtil.isDrafted(order.status)" name="timeline">
              <div class="tab-content timeline-multi">
                <Timeline :order="order" :integrationTimeLine="integrationTimeLine" :hideGateDetails="isReturnVendor"
                  :timeFormat="timeFormat" :changeTruckComments = "changeTruckComments" />
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('PACKING_NOTES')" name="packing_notes"
              v-if="isPackingIndentEnabled && order.status !== 8">
              <div class="tab-content" v-if="order">
                <PackingNotes v-if="currentSelectedTab === 'packing_notes'">
                </PackingNotes>
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('INDENT_FREIGHT_CHARGES')" name="freightcharges" v-if="isPackingIndentEnabled">
              <div class="tab-content" v-if="order">
                <FreightChargeView v-if="currentSelectedTab === 'freightcharges'" :order="order" :values="values"
                  :carrierHachRate="carrierHachRate" :contract_percentage="contract_percentage" :readOnly="false">
                </FreightChargeView>
              </div>
            </Tab-pane>
            <Tab-pane label="Audit" name="audit" v-if="isPackingIndentEnabled && order.status !== 8">
              <div class="tab-content" v-if="order">
                <PackingAuditView :order="order" v-if="currentSelectedTab === 'audit'">
                </PackingAuditView>
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('INDENT_OTHER_INFORMATION')" v-if="
                !isPackingIndentEnabled &&
                order.custom_fields &&
                customFields.length &&
                !$statusUtil.isDrafted(order.status)
              ">
              <div class="tab-content">
                <div class="status-msg my-md" v-if="!Object.keys(order.custom_fields).length">
                  <span>
                    <svgicon name="empty-timeline" width="180" height="130" :original="true" />
                    <p class="ml-30">{{ $t('INDENT_NO_DATA_FOUND') }}</p>
                  </span>
                </div>
                <div class="flex-container panel-head align-top">
                  <div class="flex-item">
                    <div v-for="(customField, customFieldIndex) in customFields" :key="`${isInbound ? 'inbound' : 'outbound'}-${
                        customField.id || customFieldIndex
                      }`">
                      <div class="custom-fields" v-if="order.custom_fields[customField.name]">
                        <p>
                          {{ customField.label }} :
                          <strong>{{
                            order.custom_fields[customField.name]
                            }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('INDENT_QUOTES')" name="QUOTES" v-if="showQuotes">
              <div class="tab-content">
                <Quotes :order="order" @reindent="setSelectedAction('RE_INDENT')" @closeDrawer="closeDrawer"
                  @rejectQuote="setRejectionPayload" />
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('INDENT_PTL_GROUPING')" name="ptl_grouping" v-if="isPtlGroupingTabVisible(order)">
              <div class="tab-content">
                <PtlGrouping :order="order" :selectedAction="selectedAction" :ptlGroups="ptlGroups ? ptlGroups : []"
                  :currentSelectedTab="currentSelectedTab" @closeDrawer="closeDrawer"
                  @changeTab="currentSelectedTab = 'actions'" @removeIndentGroup="removeIndentGroup" />
              </div>
            </Tab-pane>
            <Tab-pane :label="$t('INDENT_COMMENTS')" name="Comments">
              <div class="tab-content">
                <Comments v-if="currentSelectedTab === 'Comments'" :order="order" :configurations="configurations"
                  :timeFormat="timeFormat" @closeDrawer="closeDrawer" />
              </div>
            </Tab-pane>
          </ElTabs>
        </div>
      </div>

      <div class="status-msg" v-else>
        <span>
          <img :src="Indent" width="200" height="150" alt="" />
        </span>
      </div>
    </Drawer>
    <Dialog :visible.sync="cancelindent" width="30%" center class="dialogbox" :before-close="commentCancelClear">
      <div class="box">
        <div class="dialogbox-title">{{ $t('INDENT_CANCEL_INDENT') }}</div>
        <div class="dialogbox-body">
          <div class="dialogbox-content">
            <p>
              {{
              $t('INDENT_CANCELLATION_PROMPT', {
              order_number: order.order_number,
              })
              }}
            </p>
            <p>{{ $t('INDENT_ADD_CANCELLATION_REASON') }}</p>
          </div>
          <div class="dialogbox-subtitle">
            <div class="row no-margin">
              <div class="col-6 leftside">
                {{ $t('INDENT_COMMENT') }}
                <span class="required">*</span>
              </div>
              <div class="col-6 rightside">{{ new Date() | moment("DD MMM YYYY") }}</div>
            </div>
          </div>
          <textarea rows="3" v-model="cancelComment" :placeholder="$t('ADD_COMMENT')"></textarea>
        </div>
        <div class="dialogbox-footer">
          <button type="btn" @click="commentCancelClear" class="btn btn-secondary">
            {{ $t('INDENT_NO') }}
          </button>
          <button type="btn" @click="submitCancel" :disabled="!cancelComment.trim()" class="btn btn-primary"
            :class="{ disablebtn: !cancelComment.trim() }">
            {{ $t('INDENT_YES') }}
          </button>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="reshipindent" width="30%" center class="dialogbox">
      <div class="box">
        <div class="dialogbox-title">{{ $t('INDENT_RESHIP_INDENT') }}</div>
        <div class="dialogbox-body">
          <div class="dialogbox-content">
            <p>{{ $t('INDENT_RESHIP_PROMPT') }}</p>
          </div>
          <div class="dialogbox-subtitle">
            <div class="row no-margin">
              <div class="col-6 leftside">
                {{ $t('INDENT_RESHIP_REASON') }}
                <span class="required">*</span>
              </div>
              <div class="col-6 rightside">{{ new Date() | moment("DD MMM YYYY") }}</div>
            </div>
          </div>
          <textarea rows="3" v-model="reshipComment" :placeholder="$t('ADMIN_ADD_REASON')"></textarea>
        </div>
        <div class="dialogbox-footer">
          <button type="btn" @click="
              reshipComment = '';
              reshipindent = false;
            " class="btn btn-secondary">
            {{ $t('INDENT_RESHIP_CANCEL') }}
          </button>
          <button type="btn" :disabled="!reshipComment.trim()" @click="submitReship" class="btn btn-primary"
            :class="{ disablebtn: !reshipComment.trim() }">
            {{ $t('INDENT_RESHIP_SUCCESS') }}
          </button>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="changeShipMethod" title="Change Ship Method And Re-Ship" width="40%" class="default-dialog">
      <PackingChangeShipMethod v-if="changeShipMethod && order.id" :order="order" @closeCSMReship="closeCSMReship" />
    </Dialog>
    <Dialog :visible.sync="canceldraft" width="30%" center class="dialogbox">
      <div class="box">
        <div class="dialogbox-title">{{$t('INDENT_CANCEL_DRAFT')}}</div>
        <div class="dialogbox-body">
          <div class="dialogbox-content">
            <p>{{$t('INDENT_CANCEL_DRAFT_PROMPT')}} #{{order.order_number}}?</p>
          </div>
        </div>
        <div class="dialogbox-footer">
          <button type="btn" @click="canceldraft = false" class="btn btn-secondary">{{ $t('INDENT_NO') }}</button>
          <button type="btn" @click="submitCancelDraft" class="btn btn-primary disablebtn">{{ $t('INDENT_YES')
            }}</button>
        </div>
      </div>
    </Dialog>
    <Dialog :title="$t('INDENT_QUOTE_REJECTION')" :visible.sync="isReject" width="31%" @close="remarks=''"
      class="infodialog topmargin_n centerdialogblock">
      <div class="mb-20">
        {{ $t('INDENT_QUOTE_REJECTION_REASON') }}
      </div>
      <div class="cardbox commentarea">
        <textarea rows="3" class="comments" v-model="remarks" placeholder="REMARKS"></textarea>
      </div>
      <div class="actionbtn">
        <button type="btn" class="btn section_pbtn" @click="rejectQuote" :disabled="!remarks.trim()"
          :class="{'disabled': !remarks.trim()}">{{ $t('REJECT') }}</button>
        <button type="btn" class="btn section_pbtn" @click="isReject=false; remarks=''">{{ $t('CANCEL') }}</button>
      </div>
    </Dialog>
    <div class="slideleft_drawer" v-if="isPackingIndentEnabled">
      <div class="slideleft_content">
        <div class="content pt-20">
          <Drawer :visible.sync="manifestSlider" direction="rtl" size="400px" :withHeader="false" :append-to-body="true"
            class="default-drawer dark">
            <Link :underline="false" class="nav-close" @click="closeManifest">
            <svgicon name="cancelwhite" width="12" height="12" :original="true" />
            </Link>
            <Manifest v-if="manifestSlider" :manifestSlider="manifestSlider" @closeManifest="closeManifest">
            </Manifest>
          </Drawer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import {
  utilizationStatus,
  Movement,
  deliveryTypes,
  orderType,
  movementType as movementListType,
  movementText,
  orderTypePermissions,
  roles,
  exception,
  indentCategory,
  LorryReceiptGenerationCategory,
} from 'pando-constants';

import {
  loaders,
  paidBy,
  Menu,
  indentButtons,
  indentButtonPermission,
  filters,
  orderTypes,
  movementTypeMenu,
  deliveryList,
  deliveryListFilter,
  orderStatus,
  packingIndentStatus,
  utilizationCheck,
  searchParameters,
  InboundType,
  deliveryName,
  controlTowerParameters,
  sortOptions,
  filterOptions,
  indentActions,
  inboundIndentsParams,
  outboundIndentParams,
  materialPriorityList,
} from '@/constants/order';
import { isNumber } from 'lodash';
import { mapGetters } from 'vuex';
import FilterWrapper from '@common/components/FilterWrapperV2';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import SecFilter from '@common/components/SecFilter';
import Indent from '@common/asset/images/Indent.gif';
import CustomField from '@common/components/CustomField';
import Bg from '@common/asset/images/Sign_In.jpg';
import CustomerfieldDefinition from 'customer-field-definitions';

import { Messages } from '@/constants/messages';
import PrimaryFilter from '@/components/common/PrimaryFilter';

import Depot from '../../orders/Depot';
import ReturnDialog from '../../orders/ReturnDialog';
import Gate from '../../orders/Gate';

import Header from '../../orders/list/Header';
import Rows from '../../orders/list/Row';
import PtlGrouping from '../../orders/actions/PtlGrouping';

export default {
  components: {
    Header,
    Rows,
    PrimaryFilter,
    FilterWrapper,
    SecFilter,
    Depot,
    PtlGrouping,
    Gate,
    ReturnDialog,
    CustomField,
    Timeline: () => import(/* webpackChunkName: "Timeline", webpackPrefetch: true */ '@/components/orders/Timeline'),
    Quotes: () => import(/* webpackChunkName: "Quotes", webpackPrefetch: true */ '@/components/orders/actions/Quotes'),
    Comments: () => import(/* webpackChunkName: "Comments", webpackPrefetch: true */ '@/components/orders/actions/Comments'),
    WeighInWeightOut: () => import(/* webpackChunkName: "WeighInWeightOut", webpackPrefetch: true */ '@/components/orders/WeightInWeighOut'),
    DocumentView: () => import(/* webpackChunkName: "DocumentView", webpackPrefetch: true */ '@/components/orders/DocumentView'),
    PackingNotes: () => import(/* webpackChunkName: "PackingNotes", webpackPrefetch: true */ '@/components/orders/PackingNotes'),
    Manifest: () => import(/* webpackChunkName: "Manifest", webpackPrefetch: true */ '@/components/common/Manifest'),
    FreightChargeView: () => import(/* webpackChunkName: "FreightChargeView", webpackPrefetch: true */ '@/components/orders/FreightChargeView'),
    PackingAuditView: () => import(/* webpackChunkName: "PackingAuditView", webpackPrefetch: true */ '@/components/orders/audit/PackingAudit'),
    DeliveryDetails: () => import(/* webpackChunkName: "DeliveryDetails", webpackPrefetch: true */ '@/components/orders/DeliveryDetails'),
    Actions: () => import(/* webpackChunkName: "Actions", webpackPrefetch: true */ '@/components/orders/actions-v2/index'),
    MarkAsDeliveredActions: () => import(/* webpackChunkName: "MarkAsDeliveredActions", webpackPrefetch: true */ '@/components/orders/actions/MarkAsDelivered'),
    Track: () => import(/* webpackChunkName: "Track", webpackPrefetch: true */ '@/components/orders/actions-v2/Track'),
    PackingChangeShipMethod: () => import(/* webpackChunkName: "PackingChangeShipMethod", webpackPrefetch: true */ '@/components/orders/packing/Reship'),
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      resetFlag: false,
      numeric: '0',
      input1: '',
      Indent,
      Menu,
      isReject: false,
      remarks: '',
      rejectionPayload: null,
      indentButtons,
      indentButtonPermission,
      shouldRetryModifiedPicklist: null,
      openSlideleft: false,
      filterConstant: [],
      defaultValues: {},
      filters,
      orderTypes,
      movementTypeMenu,
      deliveryList,
      deliveryListFilter,
      orderStatus,
      packingIndentStatus,
      utilizationCheck,
      invalid_url: '',
      offset: { top: 100 },
      selectedOrder: null,
      timerTask: 6000,
      bulkRejectCount: 0,
      materialRejectCount: 0,
      podRejectionCount: 0,
      grnRejectTransactionId: '',
      materialInvoiceGrnRejectionCount: 0,
      chargeableWeightRejectCount: 0,
      lrRejectedCount: 0,
      materialInvoiceGrnRejectTransactionIds: [],
      materialDeleteTransactionIds: [],
      materialRejectTransactionIds: [],
      chargeableWeightTransactionIds: [],
      lrTransactionIds: [],
      uploadType: '',
      utilizationStatus: {},
      movement: {},
      movementListType,
      movementTypes: {},
      movementType: [],
      deliveryTypes,
      deliveryName,
      orderType: {},
      isInbound: false,
      enableSearchPopup: true,
      searchParameters,
      inboundIndentsParams,
      outboundIndentParams,
      searchedParams: {},
      searchText: 'Search',
      vendorDepots: [],
      roles,
      elDrawer: false,
      activeName: 0,
      InboundType,
      loaders,
      paidBy,
      cancelindent: false,
      reshipindent: false,
      changeShipMethod: false,
      reShipAllDeliveries: false,
      reShipProxyAllDeliveries: false,
      retryModifiedPicklistFlag: true,
      cancelComment: '',
      reshipComment: '',
      types: { DEPOT: 1, CONSIGNEE: 2, VENDOR_DEPOT: 3 },
      loadCheck: true,
      showReturnDialog: false,
      hideReturnButton: false,
      canceldraft: false,
      isInitLoading: false,
      openSearchGlobal: false,
      // module level custom changes in filter construct
      hasCustomConstruct: true,
      CustomerfieldDefinition,
      Bg,
      localTareWeight: null,
      localGrossWeight: null,
      FreezeSaveButton: true,
      isDisabledInput: false,
      createOrUpdateEvent: null,
      nullWeightReason: {
        data: '',
        custom: '',
      },
      nullUpdateOptions:
      [
        { label: 'Sheeters/Converters', type: 'sheeters_converters', checked: false },
        { label: 'Mill Outside Godown', type: 'mill_outside_godown', checked: false },
        { label: 'Incompatibility between Weighbridge and Truck', type: 'incompatibility_weighbridge_truck', checked: false },
        { label: 'Others', type: 'others', checked: false },
      ],
      selectedReason: '',
      customComment: '',
      ReasonComments: '',
      isSaveClicked: false,
      documents: [
        { label: 'Packing List', type: 'packing_list', checked: false },
        {
          label: 'Commercial Invoice',
          type: 'commercial_invoice',
          checked: false,
        },
        { label: 'Bill Of Lading', type: 'bill_of_lading', checked: false },
      ],
      values: {},
      contract_percentage: 0,
      currentSelectedTab: 'details',
      manifestSlider: false,
      controlTowerListing: false,
      controlTowerParameters,
      sort_by: null,
      setSortOptionConfig: null,
      sortOptions,
      filterOptions,
      indentActions,
      selectedFilterOption: null,

      depotConfigDetails: null,

      selectedAction: null,

      selectedCartons: new Map(),

      // Re-indent variables
      ceilingPrice: 0,
      freightUnit: 0,

      isEligibleForPtlGrouping: false,
      ptlGroups: [],
      materialPriorityList,
      ignoreList: [0, 7],
      index1: 0,
      index2: 1,
      lists: [0, 7],
      allGates: { id: -1,
        name: 'All Gates',
      },
      isIndentListView: true,
      baseFreightCharge: null,
      LorryReceiptGenerationCategory,
      tableData: [],
      showSuccessMessage: false,
      inputValue: '',
      enteredLRdetails: [],
      showTyping: false,
      isLoading: false,
      isSuccess: false,
      drawer: false,
      direction: 'rtl',

    };
  },
  props: {
    indentType: {
      type: String,
      default: 'Outbound',
    },
  },
  async created() {
    try {
      this.isInitLoading = true;
      this.$ga.set('user_logged', 'SELVA');
      this.$ga.set('dimension5', 'DIM-SELVA');
      this.$ga.set('userId', '789654');
      const filtersJSON = localStorage.getItem('ORDER_LIST_CATEGORY');
      const filter = filtersJSON ? JSON.parse(filtersJSON) : {};
      filter.page = 1;
      filter.category = this.indentType === 'Inbound' ? 1 : 0;
      this.isInbound = filter.category === 1;
      this.$store.commit('order/SET_FILTER', filter);
      this.utilizationStatus = utilizationStatus;
      this.deliveryTypes = deliveryTypes;
      this.orderType = orderType;
      this.movement = Movement;
      this.movementTypes = movementText;
      const orderTypePermitter = this.orderTypes.filter(_orderType =>
        this.$hasPermission(_orderType.view_permission),
      );
      if (orderTypePermitter.length > 1) {
        orderTypePermitter.unshift({
          name: 'All Indent Types',
          id: -1,
          tlabel: 'INDENT_ALL_INDENT_TYPES',
        });
      }
      this.orderTypes = orderTypePermitter;
      const deliveryTypeList = [...this.deliveryList];
      if (deliveryTypeList) {
        deliveryTypeList.unshift({
          id: -1,
          name: 'All Delivery Types',
          tlabel: 'INDENT_ALL_DELIVERY_TYPES',
        });
      }
      this.deliveryList = deliveryTypeList;
      if (this.configurations && this.configurations.inboundConfig) {
        const allowedMovementTypes = this.movementTypeMenu.filter((_movementType) => {
          if (!this.$hasPermission('view_return_indent') && _movementType.id === movementListType.RETURNS) {
            return false;
          } else if (!this.$hasPermission('view_vendor_indent') && _movementType.id === movementListType.INWARD) {
            return false;
          }
          return _movementType.check_config
            ? this.configurations.inboundConfig[_movementType.check_config]
            : true;
        });
        this.movementType = allowedMovementTypes;
      }
      this.$store.commit('order/SET_PAGE', 1);
      this.$store.commit('depot/RESET_DATA');
      if (this.isVendorDepotUser) {
        const params = { type: 2 };
        this.vendorDepots = await this.$store.dispatch(
          'depot/listSourceDepot',
          {
            params,
          },
        );
      }
      if (this.$route.query && this.$route.query.metricType) {
        if (this.$route.query.metricType) {
          this.controlTowerListing = true;
        }
      }
      const sortBy = JSON.parse(localStorage.getItem('indent-list-sort-by'));
      if (sortBy) {
        this.sort_by = sortBy;
        this.setSortOptionConfig = true;
      } else if (
        this.configurations &&
        this.configurations.indent_view &&
        this.configurations.indent_view.sort_by &&
        !localStorage['indent-list-sort-by']
      ) {
        this.sort_by = this.configurations.indent_view.sort_by;
        localStorage.setItem(
          'indent-list-sort-by',
          JSON.stringify(this.sort_by),
        );
        this.setSortOptionConfig = true;
      }
      this.setDefaults();
      this.loadFilters();
      this.constructSearchConstants();
      this.loadSearchFromSession();
      this.search();
      this.$store.dispatch('routes/openVehicles', { list: 'all' });
      await this.getDepotConfig();
      await this.getIndentBoostrap();
      if (this.defaultValues.depot && this.defaultValues.depot.id) {
        this.processMaterialCategories(this.defaultValues.depot, {
          category: this.filters.DEPOT,
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
    } finally {
      this.isInitLoading = false;
    }
  },

  computed: {
    ...mapGetters({
      mdmBoostrap: 'app/mdmBoostrap',
      bootstrapData: 'app/bootstrapData',
      isOrdersLoading: 'order/isLoading',
      isOrdersDetailsLoading: 'order/isOrderLoading',
      order: 'order/find',
      isVendorDepotsLoading: 'depot/isLoading',
      depots: 'app/depots',
      orders: 'order/all',
      currentDepot: 'order/currentDepot',
      currentClient: 'app/currentClient',
      currentUser: 'app/currentUser',
      isPaginating: 'order/isPaginating',
      isUploading: 'order/isUploading',
      filterParams: 'order/filter',
      isEmptyPaginate: 'order/isEmptyPaginate',
      configurations: 'app/configurations',
      customFields: 'app/customFields',
      trackingList: 'order/trackingList',
      cartonTableData: 'order/cartonTableData',
      isGlobalFilter: 'order/isGlobalFilter',
      purchaseOrderFields: 'indentV2/purchaseOrderFields',
      purchaseOrderConfig: 'indentV2/purchaseOrderConfig',
      materialCustomFields: 'indentV2/materialCustomFields',
      indentCustomFields: 'indentV2/indentCustomFields',
      indentSourceCustomFields: 'indentV2/indentSourceCustomFields',
      indentDestinationCustomFields: 'indentV2/indentDestinationCustomFields',
      integrationTimeLine: 'order/integrationTimeLine',
      changeTruckComments: 'order/changeTruckComments',
      truckDetainedConfig: 'indentV2/truckDetainedConfig',
      isBaseFreightLoading: 'paymentsV2/isBaseFreightLoading',
      indentBootstrap: 'indentV2/indentBootstrap',
      tareWeight: 'order/tareWeight',
      grossWeight: 'order/grossWeight',
      isLRLoading: 'order/isMultiLrLoading',
    }),
    hasDataLoaded() {
      return !this.isOrdersDetailsLoading && !this.isBaseFreightLoading;
    },
    hasCustomFields() {
      return (this.indentCustomFields && this.indentCustomFields.length) ||
        (this.indentSourceCustomFields && this.indentSourceCustomFields.length) ||
        (this.indentDestinationCustomFields && this.indentDestinationCustomFields.length);
    },
    deliveryWindow() {
      return !!((this.mdmBoostrap && this.mdmBoostrap.consignee && this.mdmBoostrap.consignee.length > 0));
    },
    getOrderData() {
      return !this.isPackingIndentEnabled && this.order && this.order.sources
        ? this.order.sources
        : [];
    },
    getMaterialPriorityList() {
      return this.materialPriorityList;
    },
    // Date filter options
    datePickerOptions() {
      return [
        {
          displayLabel: this.filters.CREATION_DATE,
          paramKey: 'creation',
        },
        {
          displayLabel: this.isPackingIndentEnabled
            ? this.filters.SCH_DATE
            : this.filters.VEH_DATE,
          paramKey: 'vehicle',
        },
        {
          displayLabel: this.filters.DISPATCH_DATE,
          paramKey: 'dispatch',
        },
      ];
    },

    hasDocks() {
      return this.$hasFeature('docks');
    },

    getBackDateConfig() {
      return this.configurations && this.configurations.back_date_config
        ? this.configurations.back_date_config
        : {};
    },

    datePickerFormat() {
      return this.bootstrapData.configurations &&
        this.bootstrapData.configurations.is_datepicker_24H_enabled
        ? 'dd-MM-yyyy HH:mm'
        : 'dd-MM-yyyy hh:mmA';
    },

    /* start of selected order computed fields */
    isSimTrackingAllowed() {
      const movement = this.getMovement.toLowerCase();
      return (
        (this.configurations &&
          this.configurations.track_settings &&
          this.configurations.track_settings[movement] &&
          this.configurations.track_settings[movement].enable_sim_tracking) ||
        false
      );
    },
    timeFormat() {
      return this.configurations &&
        this.configurations.is_datepicker_24H_enabled
        ? 'HH:mm'
        : 'hh:mm A';
    },
    getMovement() {
      if (this.order) {
        if (this.order.movement === this.movementListType.RETURNS) {
          return 'Return';
        } else if (this.order.movement === this.movementListType.INWARD) {
          return 'Vendor';
        } else if (this.order.movement === this.movementListType.PRIMARY) {
          return 'Primary';
        }
        return 'Secondary';
      }
      return null;
    },
    gpsTrackingEnabled() {
      return Boolean(
        this.order &&
          this.order.flow.gps_tracking &&
          this.order.flow.gps_tracking.is_enabled,
      );
    },

    simTrackingEnabled() {
      return Boolean(
        this.order &&
          this.order.flow.sim_tracking &&
          this.order.flow.sim_tracking.is_enabled,
      );
    },
    yetToTruckIn() {
      return Boolean(
        this.order &&
          this.order.sources.every(source => source.arrived_at === null),
      );
    },
    trackingAfterTruckOut() {
      return Boolean(
        this.configurations &&
          this.configurations.track_settings &&
          this.configurations.track_settings.trip_creation_event === 'TRUCK_OUT',
      );
    },
    hasDriverAccepted() {
      return Boolean(this.order && this.order.flow.driver_accepted);
    },
    hyperTrackingEnabled() {
      return !!(
        this.order.flow.app_tracking && this.order.flow.app_tracking.embed_url &&
        this.configurations.mobile_tracking_type === 'HYPERTRACK'
      );
    },
    appTrackingEnabled() {
      return !!(
        this.order.flow.app_tracking &&
        this.order.flow.app_tracking.track_trip_id && this.configurations.mobile_tracking_type === 'APP'
      );
    },
    mapConfig() {
      return this.configurations && this.configurations.map_configuration;
    },
    trackTabTitle() {
      if (
        !this.yetToTruckIn &&
        !this.simTrackingEnabled &&
        this.hasDriverAccepted &&
        this.hyperTrackingEnabled
      ) {
        return 'APP TRACK';
      }
      if (
        this.gpsTrackingEnabled ||
        (this.isSimTrackingAllowed && this.simTrackingEnabled) ||
        (this.appTrackingEnabled &&
          this.hasDriverAccepted &&
          !this.hyperTrackingEnabled)
      ) {
        return 'TRACK';
      }
      if (
        this.appTrackingEnabled &&
        this.order &&
        this.order.flow &&
        this.order.flow.app_tracking &&
        !!this.order.flow.app_tracking.track_trip_id &&
        !this.hasDriverAccepted
      ) {
        return 'TRACK';
      }
      return null;
    },
    /* end of selected order computed fields */

    listFilterOptions() {
      return this.filterOptions.filter((filterOption) => {
        if (['gate_pass', 'gate_pass_na'].includes(filterOption.id)) {
          return (
            !this.isInbound &&
            this.depotConfigDetails &&
            this.depotConfigDetails.gate_pass_applicable
          );
        }
        return true;
      });
    },
    showQuotes() {
      return (
        !this.$hasFeature('packing_indent') &&
        this.$hasFeature('truck_inspection') &&
        !this.$statusUtil.isDrafted(this.order.status)
      );
    },
    isPackingIndentEnabled() {
      return this.$hasFeature('packing_indent');
    },
    showPurchaseOrderDetails() {
      return (
        this.order.purchase_order_details &&
        this.order.purchase_order_details.po_id &&
        this.purchaseOrderConfig
      );
    },
    showEditWeighBridge() {
      return (
        this.$hasFeature('weigh_bridge') &&
        this.order &&
        this.$statusUtil
          .getStatusIds(['truck_arrived', 'loading_started', 'loading_ended'])
          .includes(this.order.status) &&
        this.$hasPermission('update_weigh_bridge')
      );
    },
    carrierHachRate() {
      return (
        (this.order.label_details && this.order.label_details.account_rate) || 0
      );
    },
    orderStatusList() {
      return this.$hasFeature('packing_indent')
        ? this.packingIndentStatus
        : this.orderStatus;
    },
    getModeOfTransport() {
      return (
        this.order &&
        this.order.ship_pack_details &&
        this.order.ship_pack_details.mode_of_transport
      );
    },
    editIndentRoute() {
      if (!this.configurations.packageDetails) {
        return {
          name: 'editOrder',
          params: {
            orderId: this.order.order_number,
            type: this.filterParams.category,
          },
        };
      }
      return {
        name: 'EditHach',
        params: { orderId: this.order.order_number },
      };
    },
    getTableCartonData() {
      const deliveryNumbers = Object.keys(this.cartonTableData);
      if (deliveryNumbers.length) {
        return this.cartonTableData[deliveryNumbers[0]].carton_details;
      }
      return [];
    },
    getTotalWtQtyVol() {
      const deliveryNumbers = Object.keys(this.cartonTableData);
      const obj = {};
      if (deliveryNumbers.length) {
        deliveryNumbers.forEach((deliveryID) => {
          let totVol = 0;
          let totWt = 0;
          let totQty = 0;
          this.cartonTableData[deliveryID].carton_details.forEach((carton) => {
            totVol += parseInt(carton.net_volume, 10);
            totWt += parseInt(carton.net_weight, 10);
            totQty += parseInt(carton.total_quantity, 10);
          });
          obj.vol = totVol;
          obj.weight = totWt;
          obj.qty = totQty;
        });
        return obj;
      }
      return {};
    },
    noOfCarton() {
      const deliveryNumbers = Object.keys(this.cartonTableData);
      if (deliveryNumbers.length) {
        return this.cartonTableData[deliveryNumbers[0]].no_of_carton;
      }
      return 0;
    },
    searchParametersWithConfig() {
      let searchParams;
      if (this.isInbound) {
        searchParams = [...this.searchParameters, ...this.inboundIndentsParams];
      } else {
        searchParams = [...this.searchParameters, ...this.outboundIndentParams];
      }
      const filteredSearchParams = searchParams.filter((val) => {
        if (val.show_feature) {
          return this.$hasFeature(val.show_feature);
        } else if (val.hide_feature) {
          return !this.$hasFeature(val.hide_feature);
        }
        return true;
      });
      const result = filteredSearchParams.map((param) => {
        if (param.multiDropDownQueryOptions) {
          const multiOptions = param.multiDropDownQueryOptions.filter((val) => {
            if (val.config) {
              return this.configurations[val.config];
            }
            return val;
          });
          return { ...param, ...{ multiDropDownQueryOptions: multiOptions } };
        }
        return param;
      });
      const otherInfoQueryInd = result.findIndex(
        _query => _query.query === 'other_info',
      );
      if (
        otherInfoQueryInd !== -1 &&
        result[otherInfoQueryInd].multiDropDownQueryOptions
      ) {
        if (this.materialCustomFields && this.materialCustomFields.length) {
          const materialCustomSearch = this.materialCustomFields
            .filter(_field => _field.is_searchable)
            .map(_field => this.constructSearchField(_field));
          if (materialCustomSearch.length) {
            result[otherInfoQueryInd].multiDropDownQueryOptions.push(
              ...materialCustomSearch,
            );
          }
        }
        // if po config enabled add the search terms in other_info search tab
        if (
          this.purchaseOrderConfig &&
          this.purchaseOrderFields &&
          this.purchaseOrderFields.length
        ) {
          // get search fields from config
          const poConfigSearchFields = this.purchaseOrderFields
            .filter(_field => _field.is_searchable)
            .map(_field => this.constructSearchField(_field));
          result[otherInfoQueryInd].multiDropDownQueryOptions.push(
            ...poConfigSearchFields,
          );
        }
        // indent custom fields search
        if (this.indentCustomFields && this.indentCustomFields.length) {
          const indentsCustomFields = this.indentCustomFields
            .filter(field => field.is_searchable)
            .map(field => this.constructSearchField(field));
          result[otherInfoQueryInd].multiDropDownQueryOptions.push(
            ...indentsCustomFields,
          );
        }
      }
      return result;
    },
    isDetailsEnabled() {
      return this.order && this.elDrawer;
    },
    seletedOption() {
      if (this.filterParams && this.filterParams.category) {
        return this.orderCategory.find(
          val => val.id === this.filterParams.category,
        );
      }
      return this.orderCategory[0];
    },
    selectedCategory() {
      const category = this.filterParams.category || 0;
      return this.menuOptions.find(menu => menu.id === category);
    },
    cloneShowStatus() {
      // order in Cancelled, requested, Draft status
      if ([25, 27, 8].includes(this.order.status)) {
        return false;
      }
      return this.$hasPermission('clone_indent');
    },
    userEditPermission() {
      const permission = {};
      const { CONTRACT, OPEN, NO_FREIGHT, MARKET } = orderTypePermissions;
      permission[this.orderType.CONTRACT] = this.$hasPermission(
        CONTRACT.update,
      );
      permission[this.orderType.OPEN] = this.$hasPermission(OPEN.update);
      permission[this.orderType.NO_FREIGHT] = this.$hasPermission(
        NO_FREIGHT.update,
      );
      permission[this.orderType.MARKET] = this.$hasPermission(MARKET.update);
      return permission;
    },
    getIndentButtons() {
      const { CONTRACT, OPEN, NO_FREIGHT, MARKET } = orderTypePermissions;
      const addPermission =
        this.$hasPermission(CONTRACT.create) ||
        this.$hasPermission(OPEN.create) ||
        this.$hasPermission(NO_FREIGHT.create) ||
        this.$hasPermission(MARKET.create) ||
        this.$hasPermission('exclusive_draft_indent_creation');
      this.indentButtons.find(button => button.name === 'Add').show =
        (this.filterParams.category === 0 || !this.isInboundConfigEnabled) &&
        addPermission;
      const rejectionButton = this.indentButtons.find(
        button => button.name === 'Rejections',
      );

      if (!this.uploadType) {
        rejectionButton.show = false;
      } else if (this.uploadType === 'indent' && this.bulkRejectCount) {
        rejectionButton.emitMethod = 'rejectDownload';
        rejectionButton.show = true;
      } else if (this.uploadType === 'grn' && this.podRejectionCount) {
        rejectionButton.emitMethod = 'grnRejectDownload';
        rejectionButton.show = true;
      } else if (this.uploadType === 'material' && this.materialRejectCount) {
        rejectionButton.emitMethod = 'materialRejectDownload';
        rejectionButton.show = true;
      } else if (
        this.uploadType === 'directDeliveryIndent' &&
        this.directDeliveryRejectCount
      ) {
        rejectionButton.emitMethod = 'directDeliveryRejectDownload';
        rejectionButton.show = true;
      } else if (
        this.uploadType === 'materialInvoiceGrn' &&
        this.materialInvoiceGrnRejectionCount
      ) {
        rejectionButton.emitMethod = 'materialInvoiceGrnRejectDownload';
        rejectionButton.show = true;
      } else if (
        this.uploadType === 'materialDeleteUpload' &&
        this.materialDeleteRejectCount
      ) {
        rejectionButton.emitMethod = 'materialDeleteRejectDownload';
        rejectionButton.show = true;
      } else if (
        this.uploadType === 'directDispatchIndent' &&
        this.directDispatchRejectCount
      ) {
        rejectionButton.emitMethod = 'directDisptchRejectDownload';
        rejectionButton.show = true;
      } else if (this.uploadType === 'chargeableWeightBulkUpload' && this.chargeableWeightRejectCount) {
        rejectionButton.emitMethod = 'chargeableWeightRejectDownload';
        rejectionButton.show = true;
      } else if (this.uploadType === 'lrBulkUpload' && this.lrRejectedCount) {
        rejectionButton.emitMethod = 'lrRejectedDownload';
        rejectionButton.show = true;
      }
      this.indentButtons.find(button => button.id === 4).show =
        this.filterParams.category === 1 &&
        addPermission && (this.$hasPermission('create_return_indent')
        || this.$hasPermission('create_vendor_indent')) &&
        this.isInboundConfigEnabled;
      // if packing_indent is enabled show manifest
      this.indentButtons.find(button => button.id === 5).show =
        this.$hasFeature('packing_indent');
      const uploadIndentButton = this.indentButtons.find(
        button => button.id === 2,
      );
      const getPermissionText =
        this.filterParams.category === 0 ? 'permission' : 'inbound_permission';

      this.indentButtons.find(button => button.id === 2).dropdownList =
        uploadIndentButton.dropdownList.reduce(
          (dropdownListUpdate, _dropdownList) => {
            const cloneDropDown = { ..._dropdownList };
            if (cloneDropDown.permission) {
              cloneDropDown.permission =
                indentButtonPermission[cloneDropDown.tlabel][getPermissionText];
            }
            dropdownListUpdate.push(cloneDropDown);
            return dropdownListUpdate;
          },
          [],
        );
      return this.indentButtons;
    },
    isInboundConfigEnabled() {
      return (
        this.configurations.inboundConfig &&
        (this.configurations.inboundConfig.return_flow ||
          this.configurations.inboundConfig.vendor_flow)
      );
    },
    getReindentClass() {
      return this.hideContractedTransporter
        ? 'modal-medium dialog-wrapper'
        : 'modal-large dialog-wrapper';
    },
    getPtlOrFtl() {
      if (
        this.order.vehicle_type &&
        this.order.vehicle_type.type === this.deliveryTypes.PTL
      ) {
        return 'PTL';
      }
      return 'FTL';
    },
    hideContractedTransporter() {
      let hide = false;
      const config = this.autoAssignTransporterConfig;
      const movement = this.getMovement.toLowerCase();
      const deliveryType = this.getPtlOrFtl.toLowerCase();
      if (
        config &&
        config[`is_enabled_for_${deliveryType}`] &&
        config[`is_enabled_for_${movement}`]
      ) {
        hide = true;
      }
      if (
        this.configurations &&
        this.configurations.enable_open_re_indent &&
        this.order.order_type === orderType.OPEN
      ) {
        hide = true;
      }
      return hide;
    },
    autoAssignTransporterConfig() {
      return this.configurations && this.configurations.auto_switch_transporter;
    },
    isVendorDepotUser() {
      return (
        this.currentUser &&
        this.currentUser.role.type === roles.VENDOR_GATE_MANAGER
      );
    },
    menuOptions() {
      const hideInbound = this.$hasPermission('hide_inbound_indents_selection') || false;
      let options = this.Menu.filter(val => val.id !== 2);
      if (this.controlTowerListing && !this.$route.query.depotId) {
        options = this.Menu.filter(val => val.id === 2);
      } else if (hideInbound || (this.bootstrapData && this.bootstrapData.initial_landing_page_settings === 'OUTBOUND')) {
        options = this.Menu.filter(val => val.id === 0);
      } else if (!hideInbound && this.bootstrapData && this.bootstrapData.initial_landing_page_settings === 'INBOUND') {
        options = this.Menu.filter(val => val.id === 1);
      }
      return options;
    },
    isDispatched() {
      const currOrderStatus = this.order.status;
      return (
        (this.$statusUtil.isDispatched(currOrderStatus) ||
          this.$statusUtil.isAfterDispatched(currOrderStatus)) &&
        currOrderStatus !== 26
      );
    },
    enableCancel() {
      // disable cancel for exim indents
      if (
        this.$hasFeature('exim_enabled') &&
        this.order &&
        this.order.exim_type
      ) {
        if (
          this.order.master_indent_movement_type === 3 &&
          this.$hasPermission('override_cancel_indent')
        ) {
          let isAllowedStatus = false;
          if (!this.order.master_indent_freight_forwarder) {
            isAllowedStatus = [0, 1, 2, 3, 4, 20, 21, 25, 16, 22, 24].includes(
              this.order.status,
            );
          } else if (!this.order.master_indent_action_complete) {
            isAllowedStatus = true;
          }
          return isAllowedStatus;
        }
        return false;
      }
      if (
        this.$hasPermission('view_pack') &&
        this.currentUser.role.type === 'read_only'
      ) {
        return false;
      }

      const currOrderStatus = this.order.status;
      return (
        !this.isDispatched ||
        (!this.$statusUtil.isDelivered(currOrderStatus) &&
          !this.$statusUtil.isCancelled(currOrderStatus) &&
          this.$hasPermission('override_cancel_indent'))
      );
    },
    enableRetryModifiedPicklist() {
      if (this.shouldRetryModifiedPicklist === null) {
        this.retryModifiedPicklistFlag =
          (this.order.retry_modified_picklist &&
            this.order.retry_modified_picklist.shouldRetry) === true;
      } else {
        this.retryModifiedPicklistFlag = this.shouldRetryModifiedPicklist;
      }
      return (
        this.retryModifiedPicklistFlag &&
        this.$hasPermission('retry_modified_picklist')
      );
    },
    hideEditIndentOption() {
      if (this.order.indent_category === indentCategory.MULTI_LEG) {
        return false;
      }
      return (
        (this.order &&
          this.order.child_indent_ids &&
          this.order.child_indent_ids.length) ||
        this.order.parentIndentId
      );
    },
    enableAddReturn() {
      const currOrderType = this.order.order_type;
      if (
        !this.hideReturnButton &&
        currOrderType === this.orderType.CONTRACT &&
        this.order.destinations &&
        this.order.destinations.length === 1 &&
        ![7, 8].includes(this.order.status) &&
        this.order.child_indent_ids &&
        !this.order.child_indent_ids.length &&
        !this.order.parentIndentId
      ) {
        return this.order.is_round_trip_eligible;
      }
      return false;
    },
    isReturnVendor() {
      return this.order && this.order.movement === this.movementListType.INWARD;
    },
    canReship() {
      const validStatus = [30, 7]; // Shipped and delivered
      return (
        validStatus.includes(this.order.status) &&
        this.$hasFeature('packing_indent') &&
        !this.order.reshipped
      );
    },
    canChangeShipMethod() {
      return (
        this.$statusUtil
          .getStatusIds(['shipped', 'delivered', 're_ship_error'])
          .includes(this.order.status) && this.$hasFeature('packing_indent')
      );
    },
    checkOrderStatus() {
      return status => (isNumber(status));
    },
    isGrossWeightFrozen() {
      const truckStatus = this.isTruckStatus(this.order.status);

      if (this.order.gross_weight != undefined || this.order.gross_weight != null) return true;

      if (truckStatus && this.localGrossWeight == null && this.order.gross_weight === undefined) {
        return false;
      }
      // return true;
    },
    isTareWeightDisabled() {
      const truckStatus = this.isTruckStatus(this.order.status);

      const hasEditPermission = this.$hasPermission('edit_truck_weights');
      let tareDisabled = false;
      if (!hasEditPermission && this.order.tare_weight !== undefined) {
        tareDisabled = true;
      } else if (!truckStatus) {
        tareDisabled = true;
      } else if (this.order.tare_weight !== undefined && hasEditPermission && truckStatus) {
        tareDisabled = false;
      }
      return tareDisabled;
    },
  },

  mounted() {
    this.$root.$on('openGlobalSearch', this.openGlobalSearch);
    this.$root.$on('closeGlobalSearch', this.closeGlobalSearch);
  },
  methods: {
    handleClose() {
      this.drawer = !this.drawer;
      this.enteredLRdetails = [];
    },
    handleBeforeClose() {
      this.drawer = true;
    },
    async downloadLRDetails(_lr) {
      const lrNumbers = _lr.lrnumber ? _lr.lrnumber : _lr.filter(lr => lr.available).map(lr => lr.lrnumber).join(',');
      if (lrNumbers) {
        await this.$store.dispatch('order/downloadMultiLR', { params: { lr_number: lrNumbers } });
      } else {
        this.$errorMessage({ message: 'E-LR Documents not found...' });
      }
    },
    async handleInput() {
      if (this.inputValue.trim()) {
        const lrNumbers = this.inputValue
          .split(',')
          .map(lr => lr.trim())
          .filter(lr => lr.length > 0);
        if (lrNumbers.length > 25) {
          this.inputValue = lrNumbers.slice(0, 25).join(', ');
        }
      }
    },
    async searchLRNumbers() {
      if (this.inputValue.trim()) {
        const lrNumbers = this.inputValue
          .split(',')
          .map(lr => lr.trim())
          .filter(lr => lr.length > 0);

        if (lrNumbers.length === 0) {
          return;
        }
        const lrPayload = this.generateLrPayload(lrNumbers);
        const result = await this.$store.dispatch('order/getMultiLrNumber', { params: lrNumbers.join(',') });
        this.$set(lrPayload, 'lrTableData', result);
        this.$set(lrPayload, 'isLoading', false);
        this.$set(lrPayload, 'showSuccessMessage', true);
        this.inputValue = '';
      }
    },
    generateLrPayload(lrNumbers) {
      this.enteredLRdetails.push({
        lrNumbers,
        isLoading: true,
        showSuccessMessage: false,
        lrTableData: [],
      });
      return this.enteredLRdetails[this.enteredLRdetails.length - 1];
    },
    async saveWeight() {
      try {
        this.checkFreezeButton();
        const tareWeight = this.localTareWeight;
        const grossWeight = this.localGrossWeight;
        if (tareWeight === undefined && grossWeight === undefined) {
          this.$errorMessage({ message: 'Please enter at least one weight (Tare or Gross).' });
          return;
        }
        if (tareWeight === 0) {
          this.FreezeSaveButton = true;
          if (
            !this.selectedReason ||
            (this.selectedReason === this.$t('OTHERS') && !this.customComment)
          ) {
            this.$errorMessage({ message: 'Please provide a reason or a comment' });
            return;
          }
        } else {
          this.FreezeSaveButton = false;
        }
        if (grossWeight === 0) {
          this.FreezeSaveButton = true;
          if (!this.selectedReason || (this.selectedReason === this.$t('OTHERS') && !this.customComment)) {
            this.$errorMessage({ message: 'Please provide a reason or a comment' });
            return;
          }
        } else {
          this.FreezeSaveButton = false;
        }
        if (tareWeight !== undefined && grossWeight !== undefined) {
          if (this.selectedReason && this.selectedReason !== this.$t('OTHERS')) {
            this.ReasonComments = this.selectedReason;
          } else if (this.customComment) {
            this.ReasonComments = this.customComment;
          }
        }
        const data = {};
        if (tareWeight !== null && tareWeight !== '') {
          data.tare_weight = tareWeight;
        }
        if (grossWeight !== null && grossWeight !== '') {
          data.gross_weight = grossWeight;
        }
        if (Object.keys(data).length === 0) {
          this.FreezeSaveButton = true;
          return;
        }
        await this.updateWeight(data, this.ReasonComments);
      } catch (error) {
        console.error('Error saving weight:', error);
      }
    },
    isTruckStatus(status) {
      return (
        [0, 1, 2, 3, 20, 21, 25].includes(status) || // for INDENTED
        [4, 16, 22, 24].includes(status) || // for ASSIGNED
        [5, 17, 18].includes(status) || // for ARRIVED
        [6].includes(status) // for DISPATCHED
      );
    },
    checkFreezeButton() {
      const truckStatus = this.isTruckStatus(this.order.status);

      this.FreezeSaveButton = true;
      if (this.localTareWeight) {
        const strValue = this.localTareWeight.toString();
        if (strValue.includes('.') && strValue.split('.')[1].length > 3) {
          const match = strValue.match(/^\d*\.?\d{0,3}/);
          this.localTareWeight = match ? parseFloat(match[0]) : null;
        }
      }
      if (this.localGrossWeight) {
        const strValue = this.localGrossWeight.toString();
        if (strValue.includes('.') && strValue.split('.')[1].length > 3) {
          const match = strValue.match(/^\d*\.?\d{0,3}/);
          this.localGrossWeight = match ? parseFloat(match[0]) : null;
        }
      }
      const tareWeight = Number(this.localTareWeight);
      const grossWeight = Number(this.localGrossWeight);

      if ((tareWeight !== null || grossWeight !== null) && truckStatus) {
        if (grossWeight === 0 || tareWeight === 0) {
          if (
            this.selectedReason &&
            (
              this.selectedReason !== this.$t('OTHERS') ||
              (this.customComment && this.customComment.length >= 15)
            )
          ) {
            this.FreezeSaveButton = false;
          } else {
            this.FreezeSaveButton = true;
          }
        } else if ((grossWeight !== 0 && grossWeight !== null) || (tareWeight !== 0 && tareWeight !== null)) {
          this.FreezeSaveButton = false;
        }
      }

      if (tareWeight === null && grossWeight === null) {
        this.FreezeSaveButton = true;
      }
    },
    async updateWeight(data, comments) {
      try {
        const params = {
          orderNo: this.order.order_number,
          data: {
            ...data,
            comments,
          },
        };
        const result = await this.$store.dispatch('order/setTruckWeight', params);
        if (result) {
          if (data.tare_weight !== undefined) {
            this.$success({ message: 'Successfully updated tare weight' });
            this.order.tare_weight = data.tare_weight;
          }
          if (data.gross_weight !== undefined && !this.order.gross_weight) {
            this.$success({ message: 'Successfully updated gross weight' });
            this.order.gross_weight = data.gross_weight;
          }
          this.closeDrawer();
        } else {
          throw new Error('Failed to update weight');
        }
      } catch (error) {
        console.error('Error updating weight:', error);
      }
    },

    handleWeights(weights) {
      this.localTareWeight = weights.tare_weight;
      this.localGrossWeight = weights.gross_weight;
    },
    disableDeliver(val, index1, index2) {
      if (val) {
        const statusGroupIndex = this.filterConstant.findIndex(constant => constant.some(item => item.queryParamString === 'status'));
        const statusIndex = this.filterConstant[statusGroupIndex].findIndex(constant => constant.queryParamString === 'status');
        let disableObj = this.filterConstant[statusGroupIndex][statusIndex].list.filter(order => this.lists.includes(order.id));
        disableObj = disableObj.map((item) => { item.$isDisabled = true; return item; });
        this.filterConstant[statusGroupIndex][statusIndex].selected = this.filterConstant[statusGroupIndex][statusIndex].selected.filter(order => !this.ignoreList.includes(order.id));
        this.filterConstant[statusGroupIndex][statusIndex].default = this.filterConstant[statusGroupIndex][statusIndex].default.filter(order => !this.ignoreList.includes(order.id));
      }
    },
    getFirstWindow(str) {
      if (str) {
        const substr = str.split(',');
        return substr[0];
      }
      return '';
    },
    getExceptFirstWindow(str) {
      if (str) {
        const substr = str.split(',');
        substr.splice(0, 1);
        return substr.join(',');
      }
      return '';
    },
    getDeliveryWindow(str) {
      if (str && str.indexOf(',') > 0) {
        const substr = str.split(',');
        const remainingCount = substr.length - 1;
        return `+${remainingCount}`;
      }
      return '';
    },
    isPtlGroupingTabVisible(order) {
      return (
        this.isEligibleForPtlGrouping &&
        (this.$statusUtil
          .getStatusIds([
            'indented',
            'indent_accepted',
            'indent_assign_due',
            'indent_accept_due',
            'indent_arrived_due',
          ])
          .includes(order.status) ||
          order.ptl_group_id)
          && (order.movement === this.movementListType.SECONDARY
          || order.movement === this.movementListType.PRIMARY)
      );
    },
    removeIndentGroup(index) {
      if (this.ptlGroups && this.ptlGroups[0].orderData) {
        this.ptlGroups[0].orderData.splice(index, 1);
      }
    },
    async getPtlGrouping({ order, actionName }) {
      this.isEligibleForPtlGrouping =
        order.vehicle_type &&
        order.vehicle_type.type === this.deliveryTypes.PTL &&
        this.$hasFeature('ptl_grouping');
      if (this.isPtlGroupingTabVisible(order)) {
        const result = await this.$store.dispatch('order/isPtlGrouping', {
          orderNo: order.order_number,
        });
        this.ptlGroups = !result || result.error ? [] : result;
        if (actionName !== 'INDENT_DETAILS') {
          this.currentSelectedTab =
            actionName &&
            [
              this.indentActions.ASSIGN_TRUCK,
              this.indentActions.UPDATE_TRUCK,
              this.indentActions.START_LOAD,
              this.indentActions.END_LOAD,
              this.indentActions.TRUCKIN,
              this.indentActions.TRUCKOUT,
            ].includes(actionName)
              ? 'ptl_grouping'
              : 'actions';
        }
      }
    },
    reindent() {
      const orderId = this.order.order_number;
      this.$router.push({
        name: 'reindentOrder',
        params: {
          orderId,
        },
      });
    },
    async processMaterialCategories(data, type) {
      if (
        type &&
        (type.tlabel
          ? this.$t(type.tlabel)
          : type.category === this.filters.DEPOT) &&
        data.id
      ) {
        const resp = await this.$store.dispatch(
          'order/getMaterialCategoriesByDepotId',
          {
            depotId: data.id,
          },
        );
        const arr = [];
        arr.push(this.defaultValues.materialPriorityList);
        resp.material_categories.map(_item => arr.push(_item));
        this.materialPriorityList = arr;
        this.filterConstant.forEach((_item, i) => {
          _item.forEach((_data, j) => {
            if (_data.category === this.filters.MATERIAL_PRIORITY) {
              this.filterConstant[i][j].list = this.materialPriorityList;
              this.filterConstant[i][j].default =
                this.defaultValues.materialPriorityList;
              this.filterConstant[i][j].selected =
                this.defaultValues.materialPriorityList;
            }
          });
        });
      }
    },
    closeCSMReship() {
      this.changeShipMethod = false;
    },
    commentCancelClear() {
      this.cancelComment = '';
      this.cancelindent = false;
    },
    async getDepotConfig() {
      const depotFilter = this.findByCategory(this.filters.DEPOT);
      const depotId = depotFilter && depotFilter.id;
      if (depotId) {
        this.depotConfigDetails = await this.$store.dispatch(
          'order/getDepotConfig',
          {
            depotId,
          },
        );
      }
    },
    async getIndentBoostrap() {
      if (this.isInbound && this.indentBootstrap && Object.keys(this.indentBootstrap).length > 0) {
        return this.indentBootstrap;
      }
      const indentBootstrap = await this.$store.dispatch('indentV2/indentBootstrap');
      return indentBootstrap;
    },
    async getBaseFreightCharges(order) {
      let paymentFetchFailed = false;
      this.baseFreightCharge = 0;
      if (!this.$hasFeature('payments_v2')) {
        this.baseFreightCharge = await this.$store.dispatch(
          'order/getPaymentCharges',
          {
            orderId: order.id,
          },
        );
      } else {
        const response = await this.$store.dispatch(
          'paymentsV2/getIndentCharges',
          {
            orderNo: order.order_number,
          },
        );
        if (response) {
          if (response.status && response.status >= 400) {
            paymentFetchFailed = true;
          } else if (response.payCharges && response.payCharges.contract_charge) {
            this.baseFreightCharge = response.payCharges.contract_charge;
          } else if (response.walletCharges && response.walletCharges.contract_charge) {
            this.baseFreightCharge = response.walletCharges.contract_charge;
          }
        }
      }
      if (paymentFetchFailed && (!this.order.base_frieght || !this.order.base_frieght.freight_charge)) {
        this.baseFreightCharge = 'NA';
      } else {
        const chargeToBeConsidered =
          this.baseFreightCharge ||
          (this.order.base_frieght && this.order.base_frieght.freight_charge) ||
          0;
        this.baseFreightCharge = Number(chargeToBeConsidered).toFixed(2);
      }
    },
    getSoldToRefIdWithCity(data) {
      let soldData;
      if (data && data.sold_to_ref_id && data.sold_to_city && data.sold_to) {
        soldData = `${data.sold_to_ref_id} - ${data.sold_to} - ${data.sold_to_city}`;
      } else if (data && data.sold_to_ref_id && data.sold_to_city) {
        soldData = `${data.sold_to_ref_id} - ${data.sold_to_city}`;
      } else {
        soldData = data.sold_to_ref_id;
      }
      return soldData;
    },
    getShippedToRefIdWithCity(data) {
      let shipData;
      if (data && data.ref_id && data.shipped_to_city && data.shipped_to) {
        shipData = `${data.ref_id} - ${data.shipped_to} - ${data.shipped_to_city}`;
      } else if (data && data.ref_id && data.shipped_to_city) {
        shipData = `${data.ref_id} - ${data.shipped_to_city}`;
      } else {
        shipData = data.ref_id;
      }
      return shipData;
    },
    updateFilterOption(value) {
      this.selectedFilterOption = value;
      this.$store.commit('order/SET_PAGE', 1);
      this.loadOrder();
    },
    clearFilterOption() {
      this.selectedFilterOption = null;
      this.$store.commit('order/SET_PAGE', 1);
      this.loadOrder();
    },
    async routeToIndents() {
      this.isInitLoading = true;
      this.controlTowerListing = false;
      if (this.isInbound) {
        this.$router.push({ name: 'InboundIndents' });
      } else {
        this.$router.push({ name: 'OutboundIndents' });
      }

      this.resetAll();
      this.search();
      await this.loadMore('filter');
    },
    sortBy(sortingOption) {
      this.sort_by = sortingOption;
      localStorage.setItem('indent-list-sort-by', JSON.stringify(this.sort_by));
      this.search();
      this.setSortOptionConfig = false;
    },
    getListHeaders() {
      const strategy = this.configurations.custom_view_strategy
        ? this.configurations.custom_view_strategy
        : 0;
      return this.CustomerfieldDefinition[strategy]['shipper-indent-listing'];
    },
    async tabchange() {
      if (this.currentSelectedTab === 'freightcharges') {
        const params = {
          indent_id: this.order.order_number,
        };
        const result = await this.$store.dispatch(
          'order/getPackingFreightCharges',
          params,
        );
        if (result && result.error) {
          this.$errorMessage({ message: 'Freight charges fetching failed!' });
        } else {
          this.values = { ...this.values, ...result };
        }
      }
    },
    getTotalWtQtyVolByDeliveryId(deliveryId) {
      let totVol = 0;
      let totWt = 0;
      let totQty = 0;
      if (this.cartonTableData[deliveryId]) {
        this.cartonTableData[deliveryId].carton_details.forEach((carton) => {
          totVol += parseInt(carton.net_volume, 10);
          totWt += parseInt(carton.net_weight, 10);
          totQty += parseInt(carton.total_quantity, 10);
        });
      }
      return {
        vol: totVol,
        weight: totWt,
        qty: totQty,
      };
    },
    openManifest() {
      this.manifestSlider = true;
    },
    closeManifest() {
      this.manifestSlider = false;
    },
    downloadDocumentation() {
      const documents = this.documents.filter(document => document.checked);
      let downloadList = [];
      documents.forEach((param) => {
        downloadList = downloadList.concat(
          this.documentationList[param.type] || [],
        );
      });
      downloadList.forEach((document) => {
        window.open(document.document_url);
      });
      if (downloadList.length === 0) {
        this.$error({ message: this.$t('INDENT_SELECT_DOCUMENT_TYPE_DOWNLOAD') });
      }
      this.documents = this.documents.map(obj =>
        (obj.checked ? { ...obj, checked: false } : obj),
      );
    },
    getMaterials(materials) {
      const materialsList = materials ? Object.keys(materials) : [];
      return materialsList.map((deliveryId) => {
        const deliveryObj = {
          deliveryId,
          cartonDetails:
            (this.cartonTableData[deliveryId] &&
              this.cartonTableData[deliveryId].carton_details) ||
            [],
          totalWeightVol: this.getTotalWtQtyVolByDeliveryId(deliveryId),
          noOfCarton:
            (this.cartonTableData[deliveryId] &&
              this.cartonTableData[deliveryId].no_of_carton) ||
            '-',
          is_parent_indent:
            (materials[deliveryId].length &&
              materials[deliveryId][0].is_parent_delivery) ||
            false,
        };
        return deliveryObj;
      });
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON =
        localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign(
        {},
        this.searchedParams,
        sessionSearchParams,
      );
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    constructSearchField(field) {
      const obj = {};
      obj.label = `in ${field.label} `;
      obj.name = field.label;
      obj.typeLabel = field.label;
      obj.query = field.name;
      return obj;
    },
    closeReturnDialog(hideReturnButton = false) {
      this.showReturnDialog = false;
      this.hideReturnButton = hideReturnButton;
      if (hideReturnButton) {
        this.closeDrawer();
      }
    },
    getGateDestinations(source) {
      const destinations = this.order.destinations;
      const gateId = source.gate_id;
      return destinations
        .filter(_destiantion => gateId === _destiantion.source_gate_id)
        .map(consignee => this.constructDestination(consignee));
    },
    constructDestination(consignee) {
      const gateId = consignee.gate_id;
      const lrCategroy = this.configurations.lorry_receipt_generate_category;
      const consignmentBooking = this.trackingList.length
        ? this.trackingList.find(
          consigneeTrack =>
            gateId === consigneeTrack.consignee_id ||
              consignee.location_id === consigneeTrack.consignee_id,
        )
        : '';
      const soldDetails =
        consignee.type === this.types.DEPOT &&
        consignee.gate_id === consignee.sold_to_id
          ? this.$depot.otherGate(consignee.sold_to_id, consignee.location_id)
          : consignee.sold_details;
      const shipToDetails =
        consignee.type === this.types.DEPOT
          ? this.$depot.otherGate(consignee.gate_id, consignee.location_id)
          : consignee.details;
      const ship_to_name = shipToDetails && shipToDetails.name;
      const sold_to_name = soldDetails && soldDetails.name;
      const result = {
        delivery_window: consignee.delivery_window,
        ref_id: (consignee.type === this.types.DEPOT && consignee.gate_id === consignee.sold_to_id) ? this.$depot.otherGate(consignee.gate_id, consignee.location_id).reference_id : consignee.details.reference_id,
        shipped_to: ship_to_name,
        sold_to_ref_id: soldDetails && soldDetails.reference_id,
        sold_to: sold_to_name,
        unloaders: consignee.unloader_available ? 'Yes' : 'No',
        paid_by: consignee.add_to_invoice ? 'Yes' : 'No',
        expected_date: consignee.expected_delivery
          ? this.bootstrapData.configurations &&
            this.bootstrapData.configurations.is_datepicker_24H_enabled
            ? this.$moment(consignee.expected_delivery).format(
              'DD MMM YYYY HH:mm',
            )
            : this.$moment(consignee.expected_delivery).format(
              'DD MMM YYYY hh:mm A',
            )
          : '-',
        consignmentNumber:
          consignmentBooking &&
          consignmentBooking.tracking_data &&
          consignmentBooking.tracking_data[0] &&
          consignmentBooking.tracking_data[0].tracking_id,
        sold_to_city: soldDetails && soldDetails.city,
        shipped_to_city: shipToDetails && shipToDetails.city,
      };
      return result;
    },
    getSourceDestinations(source) {
      const destinations = this.order.destinations;
      const locationId = source.location_id;
      return destinations
        .filter(
          _destiantion => locationId === _destiantion.source_location_id,
        )
        .map(consignee => this.constructDestination(consignee));
    },
    sourceHasGateRefrenceId(gateId, locationId, source) {
      return gateId && source.type === this.types.DEPOT
        ? this.$depot.otherGate(gateId, locationId).reference_id
        : source.details.reference_id;
    },
    sourceHasGate(gateId, locationId, source) {
      return gateId && source.type === this.types.DEPOT
        ? this.$depot.otherGate(gateId, locationId).name
        : source.details.name;
    },

    closeDrawer() {
      this.elDrawer = false;
      this.values = {};
      this.contract_percentage = 0;
      this.selectedAction = null;
      this.ptlGroups = [];
      this.baseFreightCharge = null;
      this.clearReshipSelection();
      this.$store.commit('order/SET_ORDER', {});
    },
    async rejectQuote() {
      try {
        this.rejectionPayload.payload.comment = this.remarks;
        const result = await this.$store.dispatch('order/rfqupdate', this.rejectionPayload);
        if (result && result.errors) {
          this.$errorMessage({ message: result.errors });
        } else {
          const successMessage = result.successMessage || this.$t('INDENT_UPDATED_SUCCESS_MSG');
          this.$success({ message: successMessage });
        }
        this.isReject = false;
        this.remarks = '';
        this.closeDrawer();
      } catch (e) {
        this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
      }
    },
    setRejectionPayload(data) {
      this.rejectionPayload = data;
      this.isReject = true;
    },
    setSelectedAction(action, orderId) {
      this.selectedAction = action;
      this.showOrder(orderId, 'actions');
      if (action === 'RE_INDENT') {
        this.freightUnit = (this.order && this.order.base_frieght
          && this.order.base_frieght.freight_unit) || 0;
        this.setReindentInfo(
          this.ceilingPrice,
          this.freightUnit,
          this.deliveryTypes,
        );
      }
    },
    toggleReindent(rfqData) {
      this.showReindentDialog = true;
      this.ceilingPrice = (rfqData && rfqData.ceiling_price) || 0;
      this.freightUnit = (rfqData && rfqData.quotes[0].freight_unit) || 0;
    },
    resetApply() {
      const enableObj = this.filterConstant[this.index2][this.index1].list.filter(order => this.lists.includes(order.id));
      enableObj.$isDisabled = false;
      this.resetFlag = true;
      this.selectedDateFilter = 'creation';
      this.resetAll();
      if (this.defaultValues.depot && this.defaultValues.depot.id) {
        this.processMaterialCategories(this.defaultValues.depot, {
          category: this.filters.DEPOT,
        });
      }
      this.search();
    },
    setDefaults() {
      this.setDepotDefault();
      this.defaultValues.gate = this.allGates;
      [this.defaultValues.indentType] = this.orderTypes;
      [this.defaultValues.movement] = this.movementType;
      [this.defaultValues.deliveryList] = this.deliveryList;
      [this.defaultValues.deliveryListFilter] =
        this.deliveryListFilter[0].options;
      this.defaultValues.orderStatus = this.orderStatusList;
      [this.defaultValues.utilizationCheck] = this.utilizationCheck;
      this.defaultValues.endDate = null;
      this.defaultValues.startDate = null;
      [this.defaultValues.materialPriorityList] = this.materialPriorityList;
      const gates = !this.isInbound ? (this.defaultValues.depot && this.defaultValues.depot.gates) ? [...this.defaultValues.depot.gates] : [] : (this.defaultValues.depot[0] && this.defaultValues.depot[0].gates) || [];
      gates.unshift(this.allGates);
      this.defaultValues.gates = gates;
    },
    setDepotDefault() {
      if (this.isVendorDepotUser) {
        const depotItem =
          (this.vendorDepots.length &&
            this.vendorDepots.find(
              depot => depot.id === this.filterParams.depot_id,
            )) ||
          this.vendorDepots[0];
        if (this.isInbound) {
          this.defaultValues.depot = [];
          this.defaultValues.depot.push(depotItem);
        } else {
          this.defaultValues.depot = depotItem;
        }
      } else if (this.isInbound) {
        this.defaultValues.depot = [];
        if (this.depots && this.depots.length) this.defaultValues.depot.push(this.depots[0]);
      } else if (this.depots && this.depots.length) this.defaultValues.depot = this.depots[0];
    },
    constructConstantForFilter() {
      this.resetFlag = true;
      this.filterConstant = [
        [
          {
            type: this.isInbound ? 'MultiSelectList' : 'List',
            category: this.filters.DEPOT,
            tlabel: 'INDENT_DEPOT',
            default: this.defaultValues.depot,
            selected: this.defaultValues.depot,
            list: this.isVendorDepotUser ? this.vendorDepots : this.depots,
            idLabel: 'id',
            optional: false,
            search: true,
            ...this.isInbound ? { selectAllOption: true, allowEmpty: false } : {},
            queryParamString: 'depot_id',
            placeholder: this.$t('MDM_SELECT_DEPOT'),
          },
          {
            type: 'List',
            category: this.filters.GATE,
            tlabel: 'INDENT_GATE',
            default: this.defaultValues.gate,
            selected: this.defaultValues.gate,
            list: this.defaultValues.gates,
            idLabel: 'id',
            optional: false,
            search: true,
            queryParamString: 'gate_id',
            placeholder: this.$t('INDENT_SELECT_GATE'),
          },
          {
            type: 'DatePicker',
            category: this.filters.DATE_PICKER,
            tlabel: 'INDENT_DATE_FILTER',
            radioOptions: this.datePickerOptions,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: null,
            endDate: null,
            start_date_label: 'start',
            end_date_label: 'end',
            optional: true,
            dateType: null,
          },
          {
            type: 'List',
            category: this.filters.INDENT_TYPE,
            tlabel: 'INDENT_INDENT_TYPE',
            default: this.defaultValues.indentType,
            selected: this.defaultValues.indentType,
            list: this.orderTypes,
            idLabel: 'id',
            optional: false,
            queryParamString: 'order_type',
            placeholder: 'Select type',
          },
          {
            type: 'List',
            category: this.filters.MOVEMENT,
            tlabel: 'INDENT_MOVEMENT',
            default: this.defaultValues.movement,
            selected: this.defaultValues.movement,
            list: this.movementType,
            idLabel: 'id',
            optional: false,
            queryParamString: 'movement',
            placeholder: 'Select movement',
            hasPermission: !this.$hasPermission('hide_movement_type_filter'),
          },
          {
            type: 'GroupList',
            category: this.filters.DELIVERY_TYPE_FILTER,
            tlabel: 'INDENT_DELIVERY_TYPE',
            default: this.defaultValues.deliveryListFilter,
            selected: this.defaultValues.deliveryListFilter,
            list: this.deliveryListFilter,
            idLabel: 'delivery_type_and_mode',
            parentIdLabel: 'delivery_type',
            queryParamString: 'delivery_type_and_mode',
            parentQueryParamString: 'delivery_type',
            optional: false,
            placeholder: 'Select delivery type',
            clearSelected: true,
          },
        ],
        [
          {
            type: 'MultiSelectList',
            category: this.filters.STATUS,
            tlabel: 'INDENT_STATUS',
            default: this.defaultValues.orderStatus.filter(order => !this.ignoreList.includes(order.id)),
            selected: this.defaultValues.orderStatus.filter(order => !this.ignoreList.includes(order.id)),
            list: this.orderStatusList,
            idLabel: 'id',
            optional: false,
            allowEmpty: false,
            queryParamString: 'status',
            placeholder: 'Select status',
            search: true,
          },
          {
            type: 'List',
            category: this.filters.MATERIAL_PRIORITY,
            tlabel: 'MATERIAL_PRIORITY',
            default: this.defaultValues.materialPriorityList,
            selected: this.defaultValues.materialPriorityList,
            list: this.getMaterialPriorityList,
            idLabel: 'id',
            optional: true,
            search: true,
            queryParamString: 'material_priority',
            placeholder: 'Select Material Priority',
          },
          {
            type: 'List',
            category: this.filters.UTILIZATION_CHECK,
            tlabel: 'INDENT_UTILIZATION_CHECK',
            default: this.defaultValues.utilizationCheck,
            selected: this.defaultValues.utilizationCheck,
            list: this.utilizationCheck,
            idLabel: 'id',
            optional: false,
            queryParamString: 'approval_status',
            placeholder: 'Select utilization check',
            hasPermission: this.$hasPermission('view_vehicle_utilization'),
          },
        ],
      ];
    },
    constructSearchConstants() {
      this.searchParameters.forEach((param) => {
        this.searchedParams[`${param.query}`] =
          this.defaultValues[`${param.query}`];
      });
    },
    changeCeilingPrice(value) {
      this.ceilingPrice = value;
    },
    async indentMaterialSampleDownload() {
      try {
        await this.$store.dispatch('order/dowloadAcrossIndentMaterialSample');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async indentMaterialDeleteSampleDownload() {
      try {
        await this.$store.dispatch('order/downloadMaterialDeleteSample');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async indentMaterialInvoiceGrnSampleDownload() {
      try {
        await this.$store.dispatch('order/downloadMaterialInvoiceGrnSample');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async retryModifiedPicklist() {
      try {
        const orderId = this.order.order_number;
        const result = await this.$store.dispatch(
          'order/retryModifiedPicklist',
          { orderId },
        );
        if (result.status === 'Success') {
          this.$success({
            message: this.$t('INDENT_RETRY_SUCCESS'),
          });
          this.shouldRetryModifiedPicklist = false;
          this.loadOrder();
        } else {
          this.$error({
            message: this.$t('INDENT_RETRY_FAIL'),
          });
          this.shouldRetryModifiedPicklist = true;
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async lrSampleDownload() {
      try {
        await this.$store.dispatch('order/dowloadLrBulkSample');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async indentBulkSampleDownload() {
      try {
        await this.$store.dispatch('order/dowloadAcrossIndentBulkSample');
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async directDeliveryIndentBulkSampleDownload() {
      try {
        await this.$store.dispatch(
          'order/dowloadAcrossDirectDeliveryIndentBulkSample',
        );
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async indentDirectDispatchSampleDownload() {
      try {
        await this.$store.dispatch(
          'order/dowloadAcrossDirectDispatchIndentBulkSample',
        );
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async search() {
      this.$store.commit('order/SET_PAGE', 1);
      this.applyFilters();
      if (this.filterTags && this.resetFlag) {
        const statusFilter = this.filterTags.find(ele => ele.category === 'Status');
        const indentstatusFilter = this.filterConstant[this.index2].find(ele => ele.category === 'Status');
        statusFilter.selected = statusFilter.selected.filter(order => !this.ignoreList.includes(order.id));
        indentstatusFilter.selected = indentstatusFilter.selected.filter(order => !this.ignoreList.includes(order.id));
        this.filterTags = [...this.filterTags];
        this.resetFlag = false;
      }

      this.openSlideleft = false;
      this.getDepotConfig();
      this.loadOrder();
    },
    searchByParameter(params) {
      this.searchedParams = params;
      this.$store.commit('order/SET_PAGE', 1);
      this.saveSearchToSession();
      this.loadOrder();
    },
    async loadOrder() {
      this.loadMore('filter');
    },
    async loadMore(section = 'paginate') {
      if (this.$hasFeature('packing_indent')) {
        this.openSearchGlobal = false;
      }
      if (!this.isPaginating && !this.isOrdersLoading) {
        if (section === 'paginate') {
          this.filterParams.page = this.filterParams.page + 1;
        }
        let filter = this.constructFilterPayload();

        if (this.sort_by) {
          filter.sort_by = this.sort_by;
        }
        if (this.searchedParams && Object.keys(this.searchedParams).length) {
          Object.assign(filter, { ...this.searchedParams });
        }
        if (this.selectedFilterOption) {
          filter[this.selectedFilterOption.query] = true;
        }
        if (filter) {
          filter = Object.assign(filter, {
            page: this.filterParams.page,
            category: this.filterParams.category,
          });
          if (
            ![this.deliveryName.FTL, this.deliveryName.PTL].includes(
              filter.delivery_type,
            )
          ) {
            const { delivery_type, ...newFilter } = filter;
            filter = newFilter;
          }
          if (
            this.$route.query &&
            this.$route.query.indent_no &&
            this.isPackingIndentEnabled
          ) {
            this.openGlobalSearch();
            filter.order_number = this.$route.query.indent_no;
          }
          if (
            this.$route.query &&
            this.$route.query.delivery &&
            this.isPackingIndentEnabled
          ) {
            this.openGlobalSearch();
            filter.material_ref_id = this.$route.query.delivery;
          }
          if (this.controlTowerListing) {
            filter.metricType = this.$route.query.metricType;
            if (this.$route.query.depotId) {
              filter.depot_id = this.$route.query.depotId;
            } else {
              delete filter.depot_id;
            }
            localStorage.setItem(
              'controlTowerQueryParams',
              JSON.stringify(this.$route.query),
            );
          } else {
            localStorage.removeItem('controlTowerQueryParams');
          }
          await this.$store.dispatch(`order/${section}`, { params: filter });
          this.loadCheck = this.isEmptyPaginate;
          this.isInitLoading = false;
        }
        if (section === 'filter') {
          window.scrollTo(0, 0);
        }
      }
    },

    showOrder(id, selectedTab = null) {
      this.selectedOrder = id;
      this.elDrawer = true;
      this.activeName = 0;
      this.hideReturnButton = false;
      // this.documents = this.documents.map(obj =>
      // (obj.checked ? { ...obj, checked: false } : obj));
      this.currentSelectedTab = selectedTab || 'details';
    },

    serializeObject(data) {
      const result = {};
      const dataKeys = Object.keys(data);
      dataKeys.forEach((key) => {
        if (data[key] !== null) {
          result[key] = data[key];
        }
      });
      return result;
    },

    changeStatus(status) {
      this.filter.status = status.id;
      this.filter.page = 1;
      const result = this.serializeObject(this.filter);
      this.$store.dispatch('order/filter', { filter: result });
    },

    async changedepot(depot) {
      const params = this.filterParams;
      params.depot_id = depot && depot.id;
      params.page = 1;
      const result = this.serializeObject(params);
      await this.$store.dispatch('order/filter', { params: result });
    },

    newOrder(type) {
      if (type) {
        this.$router.push({ name: 'CreateOrder', query: { type } });
      } else {
        this.$router.push({ name: 'CreateOrder' });
      }
    },

    searchOrder(query) {
      const queryLen = query.length;
      const result = this.serializeObject(this.filter);
      if (queryLen === 0) {
        this.$store.dispatch('order/filter', { filter: result });
        return;
      }
      if (queryLen >= 3) {
        this.$store.dispatch('order/search', { query });
      }
    },
    dateFilter(selected) {
      let result = '';
      if (selected) {
        const fromDate = new Date(selected).setHours(0, 0, 0, 0);
        const endDate = new Date(selected).setHours(23, 59, 59, 999);
        this.filter.start = new Date(fromDate).toISOString();
        this.filter.page = 1;
        this.filter.end = new Date(endDate).toISOString();
        result = this.serializeObject(this.filter);
      } else {
        this.filter.start = null;
        this.filter.end = null;
        this.filter.page = 1;
        result = this.serializeObject(this.filter);
      }
      this.$store.dispatch('order/filter', { filter: result });
    },
    changeCategory(category) {
      this.isInbound = parseInt(category.id, 10) === 1;
      localStorage.setItem(
        'ORDER_LIST_CATEGORY',
        JSON.stringify({ category: category.id }),
      );
      this.$emit('change-route');
    },

    async consigneePodFileUpload(file) {
      try {
        this.uploadType = 'pod';
        const result = await this.$store.dispatch('order/bulkPodUpload', {
          file,
        });
        if (result) {
          this.$success({
            message:
              this.$t('INDENT_POD_UPLOAD_MSG'),
          });
        } else {
          this.$error({ message: this.$t('INDENT_POD_UPLOAD_ERR') });
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async lrBulkUpload(data) {
      try {
        this.uploadType = 'lrBulkUpload';
        if (data) {
          this.timerTask = 6000;
          this.lrRejectedCount = 0;
          const formData = new FormData();
          formData.append('attachment', data);
          const result = await this.$store.dispatch('order/lrBulkUpload', {
            formData,
          });
          if (result.status === 204) {
            this.$success({ message: Messages.BULKUPLOAD_SUCCESS });

            const timer = setInterval(() => {
              if (!this.timerTask) {
                clearInterval(timer);
              } else {
                this.lrUploadStatus();
              }
            }, this.timerTask);
          }
          if (result.data.errors && result.data.errors.length) {
            if (result.data.errors[0].data) {
              const { data: responseData } = result.data.errors[0];
              const errorText = responseData.toString();
              this.$error({ message: `Invalid Header ${errorText}` });
            } else {
              const errorText = result.data.errors[0].message;
              this.$error({ message: `${errorText}` });
            }
          }
        } else {
          this.$error({ message: 'No file selected' });
        }
      } catch (e) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async bulkUpload(data) {
      try {
        this.uploadType = 'indent';
        if (data) {
          this.timerTask = 6000;
          this.bulkRejectCount = 0;
          const formData = new FormData();
          formData.append('attachment', data);
          const result = await this.$store.dispatch('order/bulkUpload', {
            formData,
          });
          if (result.status === 204) {
            this.$success({ message: Messages.BULKUPLOAD_SUCCESS });

            const timer = setInterval(() => {
              if (!this.timerTask) {
                clearInterval(timer);
              } else {
                this.uploadStatus();
              }
            }, this.timerTask);
          }
          if (result.data.errors && result.data.errors.length) {
            if (result.data.errors[0].data) {
              const { data: responseData } = result.data.errors[0];
              const errorText = responseData.toString();
              this.$error({ message: `Invalid Header ${errorText}` });
            } else {
              const errorText = result.data.errors[0].message;
              this.$error({ message: `${errorText}` });
            }
          }
        } else {
          this.$error({ message: 'No file selected' });
        }
      } catch (e) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async directDeliveryBulkUpload(data) {
      try {
        this.uploadType = 'directDeliveryIndent';
        if (data) {
          this.timerTask = 6000;
          this.directDeliveryRejectCount = 0;
          const formData = new FormData();
          formData.append('attachment', data);
          const result = await this.$store.dispatch(
            'order/directDeliveryBulkUpload',
            {
              formData,
            },
          );
          if (result.status === 204) {
            this.$success({ message: Messages.BULKUPLOAD_SUCCESS });

            const timer = setInterval(() => {
              if (!this.timerTask) {
                clearInterval(timer);
              } else {
                this.uploadDirectDeliveryStatus();
              }
            }, this.timerTask);
          }
          if (result.data.errors && result.data.errors.length) {
            const { data: responseData } = result.data.errors[0];
            const errorText = responseData.toString();
            this.$error({ message: `Invalid Header ${errorText}` });
          }
        } else {
          this.$error({ message: 'No file selected' });
        }
      } catch (e) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async directDispatchBulkUpload(data) {
      try {
        this.uploadType = 'directDispatchIndent';
        if (data) {
          this.timerTask = 6000;
          this.directDeliveryRejectCount = 0;
          const formData = new FormData();
          formData.append('attachment', data);
          const result = await this.$store.dispatch(
            'order/directDispatchBulkUpload',
            {
              formData,
            },
          );
          if (result.status === 204) {
            this.$success({ message: Messages.BULKUPLOAD_SUCCESS });

            const timer = setInterval(() => {
              if (!this.timerTask) {
                clearInterval(timer);
              } else {
                this.uploadDirectDispatchStatus();
              }
            }, this.timerTask);
          }
          if (result.data.errors && result.data.errors.length) {
            const { data: responseData } = result.data.errors[0];
            const errorText = responseData.toString();
            this.$error({ message: `Invalid Header ${errorText}` });
          }
        } else {
          this.$error({ message: this.$t('INDENT_NO_FILE_SELECTED') });
        }
      } catch (e) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async chargeableWeightBulkUpload(data) {
      try {
        this.uploadType = 'chargeableWeightBulkUpload';
        this.chargeableWeightTransactionIds = [];
        this.chargeableWeightRejectCount = 0;
        if (data) {
          this.timerTask = 6000;
          const formData = new FormData();
          formData.append('attachment', data);
          const result = await this.$store.dispatch('order/chargeableWeightBulkUpload', {
            formData,
          });
          if (result.status === 204) {
            this.$success({ message: Messages.BULKUPLOAD_SUCCESS });

            const timer = setInterval(() => {
              if (!this.timerTask) {
                clearInterval(timer);
              } else {
                this.chargeableWeightUploadStatus();
              }
            }, this.timerTask);
          }
          if (result.data.errors && result.data.errors.length) {
            const { data: responseData } = result.data.errors[0];
            const errorText = responseData.toString();
            this.$error({ message: `Invalid Header ${errorText}` });
          }
        } else {
          this.$error({ message: 'No file selected' });
        }
      } catch (e) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async chargeableWeightUploadStatus(data) {
      const result = await this.$store.dispatch('order/chargeableWeightUploadStatus', {
        key: data,
      });
      if (result && result.code && result.code === 'COMPLETED') {
        this.timerTask = 0;
        this.chargeableWeightRejectCount = result.invalid_count;
        this.chargeableWeightTransactionIds = result.transactionIds;
        if (result.valid_count === 0) {
          this.$error({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else if (result.invalid_count > 0) {
          this.$warningMessage({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else {
          this.$customMessage({
            message: `Chargeable Weight Bulk Upload succeeded. ${result.valid_count} record(s) uploaded successfully.`,
            duration: 30000,
          });
        }
        await this.loadOrder();
      }
      if (result.code === 'FAILED') {
        this.timerTask = 0;
        this.$error({ message: 'Unable to process your xlsx file' });
      }
    },
    async uploadDirectDispatchStatus() {
      const result = await this.$store.dispatch(
        'order/uploadDirectDispatchStatus',
        {
          section: this.currentSection,
        },
      );
      if (result.code === 'COMPLETED') {
        this.timerTask = 0;
        this.directDeliveryRejectCount = result.invalid_count;
        if (result.valid_count === 0) {
          this.$error({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else if (result.invalid_count > 0) {
          this.$warningMessage({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else {
          this.$customMessage({
            message: `Direct Dispatch Bulk Upload succeeded. ${result.valid_count} record(s) uploaded successfully.`,
            duration: 30000,
          });
        }

        await this.loadOrder();
        // await this.$store.dispatch('order/all');
      }
      if (result.code === 'FAILED') {
        this.timerTask = 0;
        this.$error({ message: this.$t('INDENT_UNABLE_TO_PROCESS`') });
      }
    },

    async uploadDirectDeliveryStatus() {
      const result = await this.$store.dispatch(
        'order/uploadDirectDeliveryStatus',
      );
      if (result.code === 'COMPLETED') {
        this.timerTask = 0;
        this.directDeliveryRejectCount = result.invalid_count;
        if (result.valid_count === 0) {
          this.$error({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else if (result.invalid_count > 0) {
          this.$warningMessage({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else {
          this.$success({
            message: ` Direct Delivery Bulk Upload succeeded. ${result.valid_count} entries uploaded successfully.`,
            duration: 30000,
          });
        }
        await this.loadOrder();
        // await this.$store.dispatch('order/all');
      }
      if (result.code === 'FAILED') {
        this.timerTask = 0;
        this.$error({ message: this.$t('INDENT_UNABLE_TO_PROCESS') });
      }
    },

    async uploadStatus() {
      const result = await this.$store.dispatch('order/uploadStatus');
      if (result.code === 'COMPLETED') {
        this.timerTask = 0;
        this.bulkRejectCount = result.invalid_count;
        if (result.valid_count === 0) {
          this.$error({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else if (result.invalid_count > 0) {
          this.$warningMessage({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else {
          this.$success({
            message: ` Indent Bulk Upload succeeded. ${result.valid_count} entries uploaded successfully.`,
            duration: 30000,
          });
        }
        await this.loadOrder();
        // await this.$store.dispatch('order/all');
      }
      if (result.code === 'FAILED') {
        this.$error({ message: this.$t('INDENT_UNABLE_TO_PROCESS') });
      }
    },

    async lrUploadStatus() {
      const result = await this.$store.dispatch('order/lrUploadStatus');
      if (result.code === 'COMPLETED') {
        this.timerTask = 0;
        this.lrRejectedCount = result.invalid_count;
        this.lrTransactionIds = result.transaction_ids;
        if (result.valid_count === 0) {
          this.$error({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count}`,
            duration: 30000,
          });
        } else if (result.invalid_count > 0) {
          this.$warningMessage({
            message: `${result.valid_count} entries uploaded and ${result.invalid_count}`,
            duration: 30000,
          });
        } else {
          this.$success({
            message: ` LR Bulk Upload succeeded. ${result.valid_count} entries uploaded successfully.`,
            duration: 30000,
          });
        }
        await this.loadOrder();
      }
      if (result.code === 'FAILED') {
        this.$error({ message: this.$t('UNABLE_TO_PROCESS') });
      }
    },

    async materialUploadStatus() {
      this.materialRejectCount = 0;
      this.materialRejectTransactionIds = [];
      const result = await this.$store.dispatch(
        'order/orderMaterialUploadStatus',
        {
          isMaterialWithPackageConfigEnabled:
            this.isMaterialWithPackageConfigEnabled(),
        },
      );
      if (result.data.code === 'COMPLETED') {
        this.timerTask = 0;
        this.materialRejectCount = result.data.invalid_count;
        this.materialRejectTransactionIds = result.data.invalid_transaction_ids;
        if (result.data.valid_count === 0) {
          this.$error({
            message: `${result.data.valid_count} entries uploaded and ${result.data.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else if (result.data.invalid_count > 0) {
          this.$warningMessage({
            message: `${result.data.valid_count} entries uploaded and ${result.data.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else {
          this.$success({
            message: ` Material Bulk Upload succeeded. ${result.data.valid_count} entries uploaded successfully.`,
            duration: 30000,
          });
        }
        await this.loadOrder();
      }
      if (result.data.code === 'FAILED') {
        this.$error({ message: this.$t('INDENT_UNABLE_TO_PROCESS') });
      }
    },

    async materialDeleteUploadStatus() {
      this.materialDeleteRejectCount = 0;
      this.materialDeleteTransactionIds = [];
      const result = await this.$store.dispatch('order/materialDeleteStatus');
      if (result.data.code === 'COMPLETED') {
        this.timerTask = 0;
        this.materialDeleteRejectCount = result.data.invalid_count;
        this.materialDeleteTransactionIds = result.data.transcationId;
        if (result.data.valid_count === 0) {
          this.$error({
            message: `${result.data.valid_count} entries uploaded and ${result.data.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else if (result.data.invalid_count > 0) {
          this.$warningMessage({
            message: `${result.data.valid_count} entries uploaded and ${result.data.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else {
          this.$success({
            message: ` Material Delete Upload succeeded. ${result.data.valid_count} entries uploaded successfully.`,
            duration: 30000,
          });
        }
        await this.loadOrder();
      }
      if (result.data.code === 'FAILED') {
        this.$error({ message: this.$t('INDENT_UNABLE_TO_PROCESS') });
      }
    },

    async materialInvoiceGrnUploadStatus() {
      this.materialInvoiceGrnRejectionCount = 0;
      this.materialInvoiceGrnRejectTransactionIds = [];
      const result = await this.$store.dispatch(
        'order/materialInvoiceGrnUploadStatus',
      );
      const json = { valid_count: 0, invalid_count: 0 };
      if (result.data.code === 'COMPLETED') {
        this.timerTask = 0;
        json.invalid_count += result.data.invalid_count;
        this.materialInvoiceGrnRejectionCount = result.data.invalid_count;
        this.materialInvoiceGrnRejectTransactionIds = [
          result.data.transcationId,
        ];
        if (result.data.valid_count === 0) {
          this.$error({
            message: `${result.data.valid_count} entries uploaded and ${result.data.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else if (result.data.invalid_count > 0) {
          this.$warningMessage({
            message: `${result.data.valid_count} entries uploaded and ${result.data.invalid_count} invalid entries were found. Invalid entries can be downloaded by clicking on REJECTIONS`,
            duration: 30000,
          });
        } else {
          this.$success({
            message: `Material Invoice GRN Upload succeeded. ${result.data.valid_count} entries uploaded successfully.`,
            duration: 30000,
          });
        }
        await this.loadOrder();
      }
      if (result.data.code === 'FAILED') {
        this.timerTask = 0;
        this.$error({ message: this.$t('INDENT_UNABLE_TO_PROCESS') });
      }
      if (result.data.code === 'PROGRESS') {
        json.invalid_count += result.data.invalid_count;
        json.valid_count += result.data.valid_count;
      }
    },

    async podBulkUpload(data) {
      try {
        this.uploadType = 'grn';
        if (data) {
          this.podRejectionCount = 0;
          this.timerTask = 6000;
          const formData = new FormData();
          formData.append('attachment', data);
          const result = await this.$store.dispatch('order/podBulkUpload', {
            formData,
          });
          if (result && result.success) {
            this.$success({ message: Messages.BULKUPLOAD_SUCCESS });
            this.podUploadStatus();

            const timer = setInterval(() => {
              if (!this.timerTask) {
                clearInterval(timer);
              } else {
                this.podUploadStatus();
              }
            }, this.timerTask);
          } else {
            this.$error({ message: result.error });
          }
        } else {
          this.$error({ message: this.$t('INDENT_NO_FILE_SELECTED') });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },

    async podUploadStatus() {
      try {
        const result = await this.$store.dispatch('order/podUploadStatus');
        if (result.code && result.code !== 'PROGRESS') {
          if (result.code === 'COMPLETED') {
            this.timerTask = 0;
            this.podRejectionCount = result.invalid_count;
            this.grnRejectTransactionId = this.podRejectionCount
              ? result.transaction_id
              : '';
            if (result.valid_count === 0) {
              this.$error({
                message: `${result.valid_count} entries uploaded and ${result.invalid_count}`,
                duration: 30000,
              });
            } else if (result.invalid_count > 0) {
              this.$warningMessage({
                message: `${result.valid_count} entries uploaded and ${result.invalid_count}`,
                duration: 30000,
              });
            } else {
              this.$success({
                message: `POD Bulk Upload succeeded. ${result.valid_count} entries uploaded successfully.`,
                duration: 30000,
              });
            }
            await this.loadOrder();
          } else {
            this.$error({ message: this.$getErr('BULK_UPLOAD_FAILS') });
          }
        } else if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (e) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    isMaterialWithPackageConfigEnabled() {
      return Boolean(
        this.configurations &&
          this.configurations.material_with_package &&
          this.configurations.material_with_package.enabled,
      );
    },

    async materialBulkUpload(invoice) {
      try {
        this.uploadType = 'material';
        this.invalid_url = '';
        this.materialRejectCount = 0;
        this.$alert({
          message: this.$t('INDENT_MATERIAL_BULK_UPLOAD_WAIT'),
          duration: 30000,
        });
        this.timerTask = 5000;
        const result = await this.$store.dispatch(
          'order/uploadOrderMaterials',
          {
            invoice,
            isMaterialWithPackageConfigEnabled:
              this.isMaterialWithPackageConfigEnabled(),
          },
        );
        if (result.status === 204) {
          this.$alert({
            message: this.$t('INDENT_MATERIAL_BULK_UPLOAD_PROCESS'),
            duration: 30000,
          });
        } else if (result.data.withinLimit) {
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.materialUploadStatus();
            }
          }, this.timerTask);
        }
        await this.loadOrder();
        if (result.data && result.data.errors && result.data.errors.length) {
          const { data: responseData } = result.data.errors[0];
          const errorText = responseData.toString();
          this.$error({ message: `Invalid Header ${errorText}` });
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async indentMaterialDeleteUpload(materials) {
      try {
        this.uploadType = 'materialDeleteUpload';
        this.invalid_url = '';
        this.materialRejectCount = 0;
        this.$alert({
          message: this.$t('INDENT_MATERIAL_DELETE_UPLOAD_PROCESS'),
          duration: 30000,
        });
        this.timerTask = 5000;
        const result = await this.$store.dispatch(
          'order/uploadOrderMaterialsDelete',
          materials,
        );
        if (result.status === 204) {
          this.$alert({
            message: this.$t('INDENT_MATERIAL_BULK_UPLOAD_PROCESS_BACKGROUND'),
            duration: 30000,
          });
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.materialDeleteUploadStatus();
            }
          }, this.timerTask);
        }
        await this.loadOrder();
        if (result.data && result.data.errors && result.data.errors.length) {
          const { data: responseData } = result.data.errors[0];
          const errorText = responseData.toString();
          this.$error({ message: `Invalid Header ${errorText}` });
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async indentMaterialInvoiceGrnBulkUpload(attachment) {
      try {
        this.uploadType = 'materialInvoiceGrn';
        this.invalid_url = '';
        this.materialInvoiceGrnRejectionCount = 0;
        this.$alert({
          message: this.$t('INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD_PROCESS'),
          duration: 30000,
        });
        this.timerTask = 5000;
        const result = await this.$store.dispatch(
          'order/materialInvoiceGrnBulkUpload',
          { attachment },
        );
        if (result.status === 204) {
          this.$alert({
            message: this.$t('INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD_PROCESS_BACKGROUND'),
            duration: 30000,
          });
          const timer = setInterval(() => {
            if (!this.timerTask) {
              clearInterval(timer);
            } else {
              this.materialInvoiceGrnUploadStatus();
            }
          }, this.timerTask);
        }
        await this.loadOrder();
        if (result.data && result.data.errors && result.data.errors.length) {
          const { data: responseData } = result.data.errors[0];
          const errorText = responseData.toString();
          this.$error({ message: `Invalid Header ${errorText}` });
        }
      } catch (err) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async rejectDownload() {
      await this.$store.dispatch('order/rejectDownload');
    },

    async grnRejectDownload() {
      await this.$store.dispatch('order/rejectDownloadGRN', {
        transactionId: this.grnRejectTransactionId,
      });
    },

    async materialRejectDownload() {
      await this.$store.dispatch('order/rejectDownloadMaterial', {
        data: {
          invalid_transaction_ids: this.materialRejectTransactionIds,
        },
        isMaterialWithPackageConfigEnabled:
          this.isMaterialWithPackageConfigEnabled(),
      });
    },
    async directDeliveryRejectDownload() {
      await this.$store.dispatch('order/directDeliveryRejectDownload');
    },
    async materialInvoiceGrnRejectDownload() {
      await this.$store.dispatch('order/materialInvoiceGrnRejectDownload', {
        data: {
          invalid_transaction_ids: this.materialInvoiceGrnRejectTransactionIds,
        },
      });
    },
    async materialDeleteRejectDownload() {
      if (this.materialDeleteRejectCount < exception.exportLimit) {
        await this.$store.dispatch('order/materialDeleteRejectDownload', {
          data: { invalid_transaction_ids: this.materialDeleteTransactionIds },
        });
      } else {
        await this.$store.dispatch('order/materialDeleteRejectSendMail', {
          data: { invalid_transaction_ids: this.materialDeleteTransactionIds },
        });
        this.$success({ message: this.$t('INDENT_REJECTION_EMAIL') });
      }
    },

    async lrRejectedDownload() {
      await this.$store.dispatch('order/lrRejectionDownload', {
        data: { transactionId: this.lrTransactionIds },
      });
    },
    async chargeableWeightRejectDownload() {
      await this.$store.dispatch('order/chargeableWeightRejectDownload', {
        data: { transactionId: this.chargeableWeightTransactionIds },
      });
    },
    async submitCancel() {
      try {
        const order = await this.$store.dispatch(
          'order/find',
          this.order.order_number,
        );
        const { order_number: id } = order;
        const result = await this.$store.dispatch('order/cancel', {
          id,
          comment: this.cancelComment,
        });
        if (result.error) {
          this.$error({ message: result.error });
        } else if (result.order_number) {
          this.$success({
            message: `Indent <b>${result.order_number}</b> has been canceled.`,
          });
          this.cancelComment = '';
          this.cancelindent = false;
          // TODO: do not put number directly, get the number based on status string.
          this.order.status = 8;
          this.closeDrawer();
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async submitCancelDraft() {
      try {
        const result = await this.$store.dispatch(
          'order/deleteDraft',
          this.order.order_number,
        );
        if (result.order_number) {
          this.$success({
            message: `Draft <b>${result.order_number}</b> has been canceled.`,
          });
          this.canceldraft = false;
          this.closeDrawer();
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async submitReship() {
      try {
        const arr = [...this.selectedCartons].map(([name, value]) => ({
          deliveryId: name,
          carton: value,
        }));
        const result = await this.$store.dispatch('order/reshipDelivery', {
          data: { order_id: this.order.id, delivery: arr },
          reShipAllDeliveries: this.reShipAllDeliveries,
          orderNo: this.order.order_number,
        });
        if (result && result.status === 204) {
          this.$successMessage({ message: this.$t('INDENT_DELIVERY_RESHIPPED') });
        } else if (result && result.data && result.data.failure) {
          this.$errorMessage({ message: result.data.failure });
        } else {
          this.$error({ message: this.$t('APP_CATCH_ERR') });
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      } finally {
        this.reshipindent = false;
        this.reshipComment = '';
      }
    },
    setGA(action, description, category = 'landing') {
      const depotFilter = this.findByCategory(this.filters.DEPOT);
      this.$addGAEvent(
        'Indent Management',
        action,
        `Indent ${category}:${description}`,
        depotFilter.name,
      );
    },
    customConstructFilter() {
      const indexValues = this.getMatrixIndexByCategory(
        this.filterConstant,
        this.filters.DEPOT,
      );
      if (indexValues) {
        const filterConstantDepotObj =
          this.filterConstant[indexValues.index1][indexValues.index2];
        const depotsList = this.isVendorDepotUser
          ? this.vendorDepots
          : this.depots;

        this.filterConstant[indexValues.index1][indexValues.index2].list =
          depotsList;
        this.setDepotDefault();
        this.filterConstant[indexValues.index1][indexValues.index2].default =
          this.defaultValues.depot;
        if (!this.isInbound) {
          this.filterConstant[indexValues.index1][indexValues.index2].selected =
          depotsList.find(
            val =>
              filterConstantDepotObj.selected &&
              filterConstantDepotObj.selected.id === val.id,
          ) || this.defaultValues.depot;
        }
        this.filterConstant = [...this.filterConstant];
      }
    },
    getMatrixIndexByCategory(details, name) {
      let index1;
      let index2;
      for (index1 = 0; index1 < details.length; ++index1) {
        const subarray = details[index1];
        for (index2 = 0; index2 < subarray.length; ++index2) {
          const tempObject = subarray[index2];
          if (tempObject.category === name) {
            return { index1, index2 };
          }
        }
      }
      return {};
    },
    resetGlobalSearch() {
      this.$router.replace({ indent_no: null, delivery: null });
      this.loadOrder();
      this.$root.$emit('resetGlobalSearch');
    },
    openGlobalSearch() {
      this.openSearchGlobal = true;
    },
    closeGlobalSearch() {
      this.openSearchGlobal = false;
    },
    cartonChange(cartons, deliveryId, fullDelivery = false, reshipAllStatus) {
      const existing = this.selectedCartons.get(deliveryId);
      const cartonCount = cartons && cartons.length;
      if (cartonCount > 0) {
        const proxy = this.selectedCartons;
        this.selectedCartons = new Map();
        proxy.set(deliveryId, {
          allSelected: reshipAllStatus ? fullDelivery : false,
          cartons,
        });
        this.selectedCartons = proxy;
      } else {
        const proxy = this.selectedCartons;
        this.selectedCartons = new Map();
        proxy.delete(deliveryId);
        this.selectedCartons = proxy;
      }
      if (
        reshipAllStatus &&
        cartonCount < existing &&
        existing.cartons &&
        existing.cartons.length
      ) {
        this.reShipProxyAllDeliveries = false;
      }
    },
    selectAllCartonChange(value, deliveryId) {
      this.selectedCartons.set(deliveryId, { allSelected: value, cartons: [] });
    },
    clearReshipSelection() {
      this.selectedCartons = new Map();
      this.reShipAllDeliveries = false;
      this.reShipProxyAllDeliveries = false;
    },
    toggleReShip() {
      this.reShipAllDeliveries = this.reShipProxyAllDeliveries;
      if (!this.reShipAllDeliveries) {
        const proxy = new Map();
        this.selectedCartons = proxy;
      }
    },
    // Re-indent related Handlers
    setReindentInfo(payload) {
      this.ceilingPrice = payload.ceilingPrice
        ? payload.ceilingPrice
        : this.ceilingPrice;
      this.freightUnit = payload.freightUnit
        ? payload.freightUnit
        : this.freightUnit;
      this.deliveryTypes = payload.deliveryTypes
        ? payload.deliveryTypes
        : this.deliveryTypes;
    },
  },
};
</script>

<style lang='scss'>
$fontSemibold: 'OpenSans-Semibold';

@keyframes flash {
  from {
    background: #aeaeae66;
  }

  to {
    background: #fff;
  }
}

.icon-container{
  position: relative;
  display: flex;
  justify-content: center;
}

.empty-lr-details{
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.background-blur {
  position: absolute;
  width: 40px;
  height: 40px;
  background-color: #FFE01BE5;
  border-radius: 50%;
  z-index: 1;
  filter: blur(30px);
}

.flash {
  animation-name: flash;
  animation-duration: 5s;
}

.loading-orders {
  padding-top: 100px;
}
.no-order-data {
  color: #3a687d;
  font-family: $fontSemibold;
  font-size: 1.5rem;
  text-transform: uppercase;
  text-align: center;
  margin-top: 100px;
}
.order {
  &-list-wrapper {
    min-height: 700px;
    padding-top: 50px;
  }
  &-row {
    display: flex;
  }
  &-col {
    font-size: 1.2rem;
  }
  &-id {
    width: 160px;
    padding-left: 12px;
  }
  &-date {
    width: 100px;
  }
  &-status {
    width: 140px;
  }
  &-route {
    width: 175px;
    cursor: pointer;
  }
  &-vendor {
    width: 150px;
  }
  &-truck {
    width: 150px;
  }
  &-actions {
    width: calc(100% - 760px);
  }
  &-accordion-btn {
    width: 30px;
    text-align: center;
    cursor: pointer;
  }
}
.hide {
  display: none;
}
.save-button-container {
  display: flex;
  justify-content: flex-end;
}
.item-group {
  display: flex;
  gap: 20px;
}
.custom-dropdown-width {
  max-width: 350px;
  width: 100%;
}
.reason-select {
  width: 100%;
  max-width: 350px;
}
.lr-details-wrapper{
  border-top: 1px solid #343440;
  padding-top: 15px;
}
.lr-details-wrapper:first-of-type {
  border-top: none;
  padding-top: 0;
}
</style>
